import { j as f2 } from "./jsx-runtime-944c88e2.js";
import { Z as p } from "./index-efd35e77.js";
import _2 from "react";
function u2(a, e) {
  var n = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(a);
    e && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(a, r).enumerable;
    })), n.push.apply(n, t);
  }
  return n;
}
function u(a) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? u2(Object(n), !0).forEach(function(t) {
      L(a, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(n)) : u2(Object(n)).forEach(function(t) {
      Object.defineProperty(a, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return a;
}
function x1(a) {
  "@babel/helpers - typeof";
  return x1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, x1(a);
}
function h4(a, e) {
  if (!(a instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function m2(a, e) {
  for (var n = 0; n < e.length; n++) {
    var t = e[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(a, t.key, t);
  }
}
function g4(a, e, n) {
  return e && m2(a.prototype, e), n && m2(a, n), Object.defineProperty(a, "prototype", {
    writable: !1
  }), a;
}
function L(a, e, n) {
  return e in a ? Object.defineProperty(a, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[e] = n, a;
}
function Q1(a, e) {
  return z4(a) || H4(a, e) || R2(a, e) || x4();
}
function l1(a) {
  return b4(a) || y4(a) || R2(a) || M4();
}
function b4(a) {
  if (Array.isArray(a))
    return T1(a);
}
function z4(a) {
  if (Array.isArray(a))
    return a;
}
function y4(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function H4(a, e) {
  var n = a == null ? null : typeof Symbol < "u" && a[Symbol.iterator] || a["@@iterator"];
  if (n != null) {
    var t = [], r = !0, c = !1, i, o;
    try {
      for (n = n.call(a); !(r = (i = n.next()).done) && (t.push(i.value), !(e && t.length === e)); r = !0)
        ;
    } catch (s) {
      c = !0, o = s;
    } finally {
      try {
        !r && n.return != null && n.return();
      } finally {
        if (c)
          throw o;
      }
    }
    return t;
  }
}
function R2(a, e) {
  if (a) {
    if (typeof a == "string")
      return T1(a, e);
    var n = Object.prototype.toString.call(a).slice(8, -1);
    if (n === "Object" && a.constructor && (n = a.constructor.name), n === "Map" || n === "Set")
      return Array.from(a);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return T1(a, e);
  }
}
function T1(a, e) {
  (e == null || e > a.length) && (e = a.length);
  for (var n = 0, t = new Array(e); n < e; n++)
    t[n] = a[n];
  return t;
}
function M4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var v2 = function() {
}, Z1 = {}, D2 = {}, F2 = null, j2 = {
  mark: v2,
  measure: v2
};
try {
  typeof window < "u" && (Z1 = window), typeof document < "u" && (D2 = document), typeof MutationObserver < "u" && (F2 = MutationObserver), typeof performance < "u" && (j2 = performance);
} catch {
}
var L4 = Z1.navigator || {}, d2 = L4.userAgent, p2 = d2 === void 0 ? "" : d2, R = Z1, b = D2, h2 = F2, m1 = j2;
R.document;
var $ = !!b.documentElement && !!b.head && typeof b.addEventListener == "function" && typeof b.createElement == "function", Y2 = ~p2.indexOf("MSIE") || ~p2.indexOf("Trident/"), v1, d1, p1, h1, g1, P = "___FONT_AWESOME___", _1 = 16, U2 = "fa", W2 = "svg-inline--fa", q = "data-fa-i2svg", R1 = "data-fa-pseudo-element", V4 = "data-fa-pseudo-element-pending", J1 = "data-prefix", a2 = "data-icon", g2 = "fontawesome-i2svg", C4 = "async", k4 = ["HTML", "HEAD", "STYLE", "SCRIPT"], q2 = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), g = "classic", z = "sharp", e2 = [g, z];
function f1(a) {
  return new Proxy(a, {
    get: function(n, t) {
      return t in n ? n[t] : n[g];
    }
  });
}
var r1 = f1((v1 = {}, L(v1, g, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  "fa-kit": "kit"
}), L(v1, z, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light"
}), v1)), c1 = f1((d1 = {}, L(d1, g, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), L(d1, z, {
  solid: "fass",
  regular: "fasr",
  light: "fasl"
}), d1)), i1 = f1((p1 = {}, L(p1, g, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), L(p1, z, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light"
}), p1)), w4 = f1((h1 = {}, L(h1, g, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), L(h1, z, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl"
}), h1)), N4 = /fa(s|r|l|t|d|b|k|ss|sr|sl)?[\-\ ]/, B2 = "fa-layers-text", A4 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, S4 = f1((g1 = {}, L(g1, g, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), L(g1, z, {
  900: "fass",
  400: "fasr",
  300: "fasl"
}), g1)), X2 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], P4 = X2.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), O4 = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], U = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, o1 = /* @__PURE__ */ new Set();
Object.keys(c1[g]).map(o1.add.bind(o1));
Object.keys(c1[z]).map(o1.add.bind(o1));
var E4 = [].concat(e2, l1(o1), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", U.GROUP, U.SWAP_OPACITY, U.PRIMARY, U.SECONDARY]).concat(X2.map(function(a) {
  return "".concat(a, "x");
})).concat(P4.map(function(a) {
  return "w-".concat(a);
})), n1 = R.FontAwesomeConfig || {};
function $4(a) {
  var e = b.querySelector("script[" + a + "]");
  if (e)
    return e.getAttribute(a);
}
function I4(a) {
  return a === "" ? !0 : a === "false" ? !1 : a === "true" ? !0 : a;
}
if (b && typeof b.querySelector == "function") {
  var T4 = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  T4.forEach(function(a) {
    var e = Q1(a, 2), n = e[0], t = e[1], r = I4($4(n));
    r != null && (n1[t] = r);
  });
}
var G2 = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: U2,
  replacementClass: W2,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
n1.familyPrefix && (n1.cssPrefix = n1.familyPrefix);
var Z = u(u({}, G2), n1);
Z.autoReplaceSvg || (Z.observeMutations = !1);
var v = {};
Object.keys(G2).forEach(function(a) {
  Object.defineProperty(v, a, {
    enumerable: !0,
    set: function(n) {
      Z[a] = n, t1.forEach(function(t) {
        return t(v);
      });
    },
    get: function() {
      return Z[a];
    }
  });
});
Object.defineProperty(v, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    Z.cssPrefix = e, t1.forEach(function(n) {
      return n(v);
    });
  },
  get: function() {
    return Z.cssPrefix;
  }
});
R.FontAwesomeConfig = v;
var t1 = [];
function _4(a) {
  return t1.push(a), function() {
    t1.splice(t1.indexOf(a), 1);
  };
}
var T = _1, S = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function R4(a) {
  if (!(!a || !$)) {
    var e = b.createElement("style");
    e.setAttribute("type", "text/css"), e.innerHTML = a;
    for (var n = b.head.childNodes, t = null, r = n.length - 1; r > -1; r--) {
      var c = n[r], i = (c.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(i) > -1 && (t = c);
    }
    return b.head.insertBefore(e, t), a;
  }
}
var D4 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function s1() {
  for (var a = 12, e = ""; a-- > 0; )
    e += D4[Math.random() * 62 | 0];
  return e;
}
function a1(a) {
  for (var e = [], n = (a || []).length >>> 0; n--; )
    e[n] = a[n];
  return e;
}
function n2(a) {
  return a.classList ? a1(a.classList) : (a.getAttribute("class") || "").split(" ").filter(function(e) {
    return e;
  });
}
function K2(a) {
  return "".concat(a).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function F4(a) {
  return Object.keys(a || {}).reduce(function(e, n) {
    return e + "".concat(n, '="').concat(K2(a[n]), '" ');
  }, "").trim();
}
function k1(a) {
  return Object.keys(a || {}).reduce(function(e, n) {
    return e + "".concat(n, ": ").concat(a[n].trim(), ";");
  }, "");
}
function t2(a) {
  return a.size !== S.size || a.x !== S.x || a.y !== S.y || a.rotate !== S.rotate || a.flipX || a.flipY;
}
function j4(a) {
  var e = a.transform, n = a.containerWidth, t = a.iconWidth, r = {
    transform: "translate(".concat(n / 2, " 256)")
  }, c = "translate(".concat(e.x * 32, ", ").concat(e.y * 32, ") "), i = "scale(".concat(e.size / 16 * (e.flipX ? -1 : 1), ", ").concat(e.size / 16 * (e.flipY ? -1 : 1), ") "), o = "rotate(".concat(e.rotate, " 0 0)"), s = {
    transform: "".concat(c, " ").concat(i, " ").concat(o)
  }, f = {
    transform: "translate(".concat(t / 2 * -1, " -256)")
  };
  return {
    outer: r,
    inner: s,
    path: f
  };
}
function Y4(a) {
  var e = a.transform, n = a.width, t = n === void 0 ? _1 : n, r = a.height, c = r === void 0 ? _1 : r, i = a.startCentered, o = i === void 0 ? !1 : i, s = "";
  return o && Y2 ? s += "translate(".concat(e.x / T - t / 2, "em, ").concat(e.y / T - c / 2, "em) ") : o ? s += "translate(calc(-50% + ".concat(e.x / T, "em), calc(-50% + ").concat(e.y / T, "em)) ") : s += "translate(".concat(e.x / T, "em, ").concat(e.y / T, "em) "), s += "scale(".concat(e.size / T * (e.flipX ? -1 : 1), ", ").concat(e.size / T * (e.flipY ? -1 : 1), ") "), s += "rotate(".concat(e.rotate, "deg) "), s;
}
var U4 = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, none));
          transform: rotate(var(--fa-rotate-angle, none));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function Q2() {
  var a = U2, e = W2, n = v.cssPrefix, t = v.replacementClass, r = U4;
  if (n !== a || t !== e) {
    var c = new RegExp("\\.".concat(a, "\\-"), "g"), i = new RegExp("\\--".concat(a, "\\-"), "g"), o = new RegExp("\\.".concat(e), "g");
    r = r.replace(c, ".".concat(n, "-")).replace(i, "--".concat(n, "-")).replace(o, ".".concat(t));
  }
  return r;
}
var b2 = !1;
function P1() {
  v.autoAddCss && !b2 && (R4(Q2()), b2 = !0);
}
var W4 = {
  mixout: function() {
    return {
      dom: {
        css: Q2,
        insertCss: P1
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        P1();
      },
      beforeI2svg: function() {
        P1();
      }
    };
  }
}, O = R || {};
O[P] || (O[P] = {});
O[P].styles || (O[P].styles = {});
O[P].hooks || (O[P].hooks = {});
O[P].shims || (O[P].shims = []);
var A = O[P], Z2 = [], q4 = function a() {
  b.removeEventListener("DOMContentLoaded", a), L1 = 1, Z2.map(function(e) {
    return e();
  });
}, L1 = !1;
$ && (L1 = (b.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(b.readyState), L1 || b.addEventListener("DOMContentLoaded", q4));
function B4(a) {
  $ && (L1 ? setTimeout(a, 0) : Z2.push(a));
}
function u1(a) {
  var e = a.tag, n = a.attributes, t = n === void 0 ? {} : n, r = a.children, c = r === void 0 ? [] : r;
  return typeof a == "string" ? K2(a) : "<".concat(e, " ").concat(F4(t), ">").concat(c.map(u1).join(""), "</").concat(e, ">");
}
function z2(a, e, n) {
  if (a && a[e] && a[e][n])
    return {
      prefix: e,
      iconName: n,
      icon: a[e][n]
    };
}
var X4 = function(e, n) {
  return function(t, r, c, i) {
    return e.call(n, t, r, c, i);
  };
}, O1 = function(e, n, t, r) {
  var c = Object.keys(e), i = c.length, o = r !== void 0 ? X4(n, r) : n, s, f, l;
  for (t === void 0 ? (s = 1, l = e[c[0]]) : (s = 0, l = t); s < i; s++)
    f = c[s], l = o(l, e[f], f, e);
  return l;
};
function G4(a) {
  for (var e = [], n = 0, t = a.length; n < t; ) {
    var r = a.charCodeAt(n++);
    if (r >= 55296 && r <= 56319 && n < t) {
      var c = a.charCodeAt(n++);
      (c & 64512) == 56320 ? e.push(((r & 1023) << 10) + (c & 1023) + 65536) : (e.push(r), n--);
    } else
      e.push(r);
  }
  return e;
}
function D1(a) {
  var e = G4(a);
  return e.length === 1 ? e[0].toString(16) : null;
}
function K4(a, e) {
  var n = a.length, t = a.charCodeAt(e), r;
  return t >= 55296 && t <= 56319 && n > e + 1 && (r = a.charCodeAt(e + 1), r >= 56320 && r <= 57343) ? (t - 55296) * 1024 + r - 56320 + 65536 : t;
}
function y2(a) {
  return Object.keys(a).reduce(function(e, n) {
    var t = a[n], r = !!t.icon;
    return r ? e[t.iconName] = t.icon : e[n] = t, e;
  }, {});
}
function F1(a, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, t = n.skipHooks, r = t === void 0 ? !1 : t, c = y2(e);
  typeof A.hooks.addPack == "function" && !r ? A.hooks.addPack(a, y2(e)) : A.styles[a] = u(u({}, A.styles[a] || {}), c), a === "fas" && F1("fa", e);
}
var b1, z1, y1, X = A.styles, Q4 = A.shims, Z4 = (b1 = {}, L(b1, g, Object.values(i1[g])), L(b1, z, Object.values(i1[z])), b1), r2 = null, J2 = {}, a4 = {}, e4 = {}, n4 = {}, t4 = {}, J4 = (z1 = {}, L(z1, g, Object.keys(r1[g])), L(z1, z, Object.keys(r1[z])), z1);
function a3(a) {
  return ~E4.indexOf(a);
}
function e3(a, e) {
  var n = e.split("-"), t = n[0], r = n.slice(1).join("-");
  return t === a && r !== "" && !a3(r) ? r : null;
}
var r4 = function() {
  var e = function(c) {
    return O1(X, function(i, o, s) {
      return i[s] = O1(o, c, {}), i;
    }, {});
  };
  J2 = e(function(r, c, i) {
    if (c[3] && (r[c[3]] = i), c[2]) {
      var o = c[2].filter(function(s) {
        return typeof s == "number";
      });
      o.forEach(function(s) {
        r[s.toString(16)] = i;
      });
    }
    return r;
  }), a4 = e(function(r, c, i) {
    if (r[i] = i, c[2]) {
      var o = c[2].filter(function(s) {
        return typeof s == "string";
      });
      o.forEach(function(s) {
        r[s] = i;
      });
    }
    return r;
  }), t4 = e(function(r, c, i) {
    var o = c[2];
    return r[i] = i, o.forEach(function(s) {
      r[s] = i;
    }), r;
  });
  var n = "far" in X || v.autoFetchSvg, t = O1(Q4, function(r, c) {
    var i = c[0], o = c[1], s = c[2];
    return o === "far" && !n && (o = "fas"), typeof i == "string" && (r.names[i] = {
      prefix: o,
      iconName: s
    }), typeof i == "number" && (r.unicodes[i.toString(16)] = {
      prefix: o,
      iconName: s
    }), r;
  }, {
    names: {},
    unicodes: {}
  });
  e4 = t.names, n4 = t.unicodes, r2 = w1(v.styleDefault, {
    family: v.familyDefault
  });
};
_4(function(a) {
  r2 = w1(a.styleDefault, {
    family: v.familyDefault
  });
});
r4();
function c2(a, e) {
  return (J2[a] || {})[e];
}
function n3(a, e) {
  return (a4[a] || {})[e];
}
function W(a, e) {
  return (t4[a] || {})[e];
}
function c4(a) {
  return e4[a] || {
    prefix: null,
    iconName: null
  };
}
function t3(a) {
  var e = n4[a], n = c2("fas", a);
  return e || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function D() {
  return r2;
}
var i2 = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function w1(a) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.family, t = n === void 0 ? g : n, r = r1[t][a], c = c1[t][a] || c1[t][r], i = a in A.styles ? a : null;
  return c || i || null;
}
var H2 = (y1 = {}, L(y1, g, Object.keys(i1[g])), L(y1, z, Object.keys(i1[z])), y1);
function N1(a) {
  var e, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.skipLookups, r = t === void 0 ? !1 : t, c = (e = {}, L(e, g, "".concat(v.cssPrefix, "-").concat(g)), L(e, z, "".concat(v.cssPrefix, "-").concat(z)), e), i = null, o = g;
  (a.includes(c[g]) || a.some(function(f) {
    return H2[g].includes(f);
  })) && (o = g), (a.includes(c[z]) || a.some(function(f) {
    return H2[z].includes(f);
  })) && (o = z);
  var s = a.reduce(function(f, l) {
    var m = e3(v.cssPrefix, l);
    if (X[l] ? (l = Z4[o].includes(l) ? w4[o][l] : l, i = l, f.prefix = l) : J4[o].indexOf(l) > -1 ? (i = l, f.prefix = w1(l, {
      family: o
    })) : m ? f.iconName = m : l !== v.replacementClass && l !== c[g] && l !== c[z] && f.rest.push(l), !r && f.prefix && f.iconName) {
      var d = i === "fa" ? c4(f.iconName) : {}, h = W(f.prefix, f.iconName);
      d.prefix && (i = null), f.iconName = d.iconName || h || f.iconName, f.prefix = d.prefix || f.prefix, f.prefix === "far" && !X.far && X.fas && !v.autoFetchSvg && (f.prefix = "fas");
    }
    return f;
  }, i2());
  return (a.includes("fa-brands") || a.includes("fab")) && (s.prefix = "fab"), (a.includes("fa-duotone") || a.includes("fad")) && (s.prefix = "fad"), !s.prefix && o === z && (X.fass || v.autoFetchSvg) && (s.prefix = "fass", s.iconName = W(s.prefix, s.iconName) || s.iconName), (s.prefix === "fa" || i === "fa") && (s.prefix = D() || "fas"), s;
}
var r3 = /* @__PURE__ */ function() {
  function a() {
    h4(this, a), this.definitions = {};
  }
  return g4(a, [{
    key: "add",
    value: function() {
      for (var n = this, t = arguments.length, r = new Array(t), c = 0; c < t; c++)
        r[c] = arguments[c];
      var i = r.reduce(this._pullDefinitions, {});
      Object.keys(i).forEach(function(o) {
        n.definitions[o] = u(u({}, n.definitions[o] || {}), i[o]), F1(o, i[o]);
        var s = i1[g][o];
        s && F1(s, i[o]), r4();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(n, t) {
      var r = t.prefix && t.iconName && t.icon ? {
        0: t
      } : t;
      return Object.keys(r).map(function(c) {
        var i = r[c], o = i.prefix, s = i.iconName, f = i.icon, l = f[2];
        n[o] || (n[o] = {}), l.length > 0 && l.forEach(function(m) {
          typeof m == "string" && (n[o][m] = f);
        }), n[o][s] = f;
      }), n;
    }
  }]), a;
}(), M2 = [], G = {}, Q = {}, c3 = Object.keys(Q);
function i3(a, e) {
  var n = e.mixoutsTo;
  return M2 = a, G = {}, Object.keys(Q).forEach(function(t) {
    c3.indexOf(t) === -1 && delete Q[t];
  }), M2.forEach(function(t) {
    var r = t.mixout ? t.mixout() : {};
    if (Object.keys(r).forEach(function(i) {
      typeof r[i] == "function" && (n[i] = r[i]), x1(r[i]) === "object" && Object.keys(r[i]).forEach(function(o) {
        n[i] || (n[i] = {}), n[i][o] = r[i][o];
      });
    }), t.hooks) {
      var c = t.hooks();
      Object.keys(c).forEach(function(i) {
        G[i] || (G[i] = []), G[i].push(c[i]);
      });
    }
    t.provides && t.provides(Q);
  }), n;
}
function j1(a, e) {
  for (var n = arguments.length, t = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)
    t[r - 2] = arguments[r];
  var c = G[a] || [];
  return c.forEach(function(i) {
    e = i.apply(null, [e].concat(t));
  }), e;
}
function B(a) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), t = 1; t < e; t++)
    n[t - 1] = arguments[t];
  var r = G[a] || [];
  r.forEach(function(c) {
    c.apply(null, n);
  });
}
function E() {
  var a = arguments[0], e = Array.prototype.slice.call(arguments, 1);
  return Q[a] ? Q[a].apply(null, e) : void 0;
}
function Y1(a) {
  a.prefix === "fa" && (a.prefix = "fas");
  var e = a.iconName, n = a.prefix || D();
  if (e)
    return e = W(n, e) || e, z2(i4.definitions, n, e) || z2(A.styles, n, e);
}
var i4 = new r3(), o3 = function() {
  v.autoReplaceSvg = !1, v.observeMutations = !1, B("noAuto");
}, s3 = {
  i2svg: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return $ ? (B("beforeI2svg", e), E("pseudoElements2svg", e), E("i2svg", e)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.autoReplaceSvgRoot;
    v.autoReplaceSvg === !1 && (v.autoReplaceSvg = !0), v.observeMutations = !0, B4(function() {
      f3({
        autoReplaceSvgRoot: n
      }), B("watch", e);
    });
  }
}, l3 = {
  icon: function(e) {
    if (e === null)
      return null;
    if (x1(e) === "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: W(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      var n = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], t = w1(e[0]);
      return {
        prefix: t,
        iconName: W(t, n) || n
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(v.cssPrefix, "-")) > -1 || e.match(N4))) {
      var r = N1(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: r.prefix || D(),
        iconName: W(r.prefix, r.iconName) || r.iconName
      };
    }
    if (typeof e == "string") {
      var c = D();
      return {
        prefix: c,
        iconName: W(c, e) || e
      };
    }
  }
}, N = {
  noAuto: o3,
  config: v,
  dom: s3,
  parse: l3,
  library: i4,
  findIconDefinition: Y1,
  toHtml: u1
}, f3 = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.autoReplaceSvgRoot, t = n === void 0 ? b : n;
  (Object.keys(A.styles).length > 0 || v.autoFetchSvg) && $ && v.autoReplaceSvg && N.dom.i2svg({
    node: t
  });
};
function A1(a, e) {
  return Object.defineProperty(a, "abstract", {
    get: e
  }), Object.defineProperty(a, "html", {
    get: function() {
      return a.abstract.map(function(t) {
        return u1(t);
      });
    }
  }), Object.defineProperty(a, "node", {
    get: function() {
      if ($) {
        var t = b.createElement("div");
        return t.innerHTML = a.html, t.children;
      }
    }
  }), a;
}
function u3(a) {
  var e = a.children, n = a.main, t = a.mask, r = a.attributes, c = a.styles, i = a.transform;
  if (t2(i) && n.found && !t.found) {
    var o = n.width, s = n.height, f = {
      x: o / s / 2,
      y: 0.5
    };
    r.style = k1(u(u({}, c), {}, {
      "transform-origin": "".concat(f.x + i.x / 16, "em ").concat(f.y + i.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: r,
    children: e
  }];
}
function m3(a) {
  var e = a.prefix, n = a.iconName, t = a.children, r = a.attributes, c = a.symbol, i = c === !0 ? "".concat(e, "-").concat(v.cssPrefix, "-").concat(n) : c;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: u(u({}, r), {}, {
        id: i
      }),
      children: t
    }]
  }];
}
function o2(a) {
  var e = a.icons, n = e.main, t = e.mask, r = a.prefix, c = a.iconName, i = a.transform, o = a.symbol, s = a.title, f = a.maskId, l = a.titleId, m = a.extra, d = a.watchable, h = d === void 0 ? !1 : d, M = t.found ? t : n, C = M.width, y = M.height, k = r === "fak", H = [v.replacementClass, c ? "".concat(v.cssPrefix, "-").concat(c) : ""].filter(function(I) {
    return m.classes.indexOf(I) === -1;
  }).filter(function(I) {
    return I !== "" || !!I;
  }).concat(m.classes).join(" "), x = {
    children: [],
    attributes: u(u({}, m.attributes), {}, {
      "data-prefix": r,
      "data-icon": c,
      class: H,
      role: m.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(C, " ").concat(y)
    })
  }, w = k && !~m.classes.indexOf("fa-fw") ? {
    width: "".concat(C / y * 16 * 0.0625, "em")
  } : {};
  h && (x.attributes[q] = ""), s && (x.children.push({
    tag: "title",
    attributes: {
      id: x.attributes["aria-labelledby"] || "title-".concat(l || s1())
    },
    children: [s]
  }), delete x.attributes.title);
  var V = u(u({}, x), {}, {
    prefix: r,
    iconName: c,
    main: n,
    mask: t,
    maskId: f,
    transform: i,
    symbol: o,
    styles: u(u({}, w), m.styles)
  }), j = t.found && n.found ? E("generateAbstractMask", V) || {
    children: [],
    attributes: {}
  } : E("generateAbstractIcon", V) || {
    children: [],
    attributes: {}
  }, Y = j.children, S1 = j.attributes;
  return V.children = Y, V.attributes = S1, o ? m3(V) : u3(V);
}
function x2(a) {
  var e = a.content, n = a.width, t = a.height, r = a.transform, c = a.title, i = a.extra, o = a.watchable, s = o === void 0 ? !1 : o, f = u(u(u({}, i.attributes), c ? {
    title: c
  } : {}), {}, {
    class: i.classes.join(" ")
  });
  s && (f[q] = "");
  var l = u({}, i.styles);
  t2(r) && (l.transform = Y4({
    transform: r,
    startCentered: !0,
    width: n,
    height: t
  }), l["-webkit-transform"] = l.transform);
  var m = k1(l);
  m.length > 0 && (f.style = m);
  var d = [];
  return d.push({
    tag: "span",
    attributes: f,
    children: [e]
  }), c && d.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [c]
  }), d;
}
function v3(a) {
  var e = a.content, n = a.title, t = a.extra, r = u(u(u({}, t.attributes), n ? {
    title: n
  } : {}), {}, {
    class: t.classes.join(" ")
  }), c = k1(t.styles);
  c.length > 0 && (r.style = c);
  var i = [];
  return i.push({
    tag: "span",
    attributes: r,
    children: [e]
  }), n && i.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), i;
}
var E1 = A.styles;
function U1(a) {
  var e = a[0], n = a[1], t = a.slice(4), r = Q1(t, 1), c = r[0], i = null;
  return Array.isArray(c) ? i = {
    tag: "g",
    attributes: {
      class: "".concat(v.cssPrefix, "-").concat(U.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(v.cssPrefix, "-").concat(U.SECONDARY),
        fill: "currentColor",
        d: c[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(v.cssPrefix, "-").concat(U.PRIMARY),
        fill: "currentColor",
        d: c[1]
      }
    }]
  } : i = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: c
    }
  }, {
    found: !0,
    width: e,
    height: n,
    icon: i
  };
}
var d3 = {
  found: !1,
  width: 512,
  height: 512
};
function p3(a, e) {
  !q2 && !v.showMissingIcons && a && console.error('Icon with name "'.concat(a, '" and prefix "').concat(e, '" is missing.'));
}
function W1(a, e) {
  var n = e;
  return e === "fa" && v.styleDefault !== null && (e = D()), new Promise(function(t, r) {
    if (E("missingIconAbstract"), n === "fa") {
      var c = c4(a) || {};
      a = c.iconName || a, e = c.prefix || e;
    }
    if (a && e && E1[e] && E1[e][a]) {
      var i = E1[e][a];
      return t(U1(i));
    }
    p3(a, e), t(u(u({}, d3), {}, {
      icon: v.showMissingIcons && a ? E("missingIconAbstract") || {} : {}
    }));
  });
}
var L2 = function() {
}, q1 = v.measurePerformance && m1 && m1.mark && m1.measure ? m1 : {
  mark: L2,
  measure: L2
}, e1 = 'FA "6.4.0"', h3 = function(e) {
  return q1.mark("".concat(e1, " ").concat(e, " begins")), function() {
    return o4(e);
  };
}, o4 = function(e) {
  q1.mark("".concat(e1, " ").concat(e, " ends")), q1.measure("".concat(e1, " ").concat(e), "".concat(e1, " ").concat(e, " begins"), "".concat(e1, " ").concat(e, " ends"));
}, s2 = {
  begin: h3,
  end: o4
}, H1 = function() {
};
function V2(a) {
  var e = a.getAttribute ? a.getAttribute(q) : null;
  return typeof e == "string";
}
function g3(a) {
  var e = a.getAttribute ? a.getAttribute(J1) : null, n = a.getAttribute ? a.getAttribute(a2) : null;
  return e && n;
}
function b3(a) {
  return a && a.classList && a.classList.contains && a.classList.contains(v.replacementClass);
}
function z3() {
  if (v.autoReplaceSvg === !0)
    return M1.replace;
  var a = M1[v.autoReplaceSvg];
  return a || M1.replace;
}
function y3(a) {
  return b.createElementNS("http://www.w3.org/2000/svg", a);
}
function H3(a) {
  return b.createElement(a);
}
function s4(a) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.ceFn, t = n === void 0 ? a.tag === "svg" ? y3 : H3 : n;
  if (typeof a == "string")
    return b.createTextNode(a);
  var r = t(a.tag);
  Object.keys(a.attributes || []).forEach(function(i) {
    r.setAttribute(i, a.attributes[i]);
  });
  var c = a.children || [];
  return c.forEach(function(i) {
    r.appendChild(s4(i, {
      ceFn: t
    }));
  }), r;
}
function M3(a) {
  var e = " ".concat(a.outerHTML, " ");
  return e = "".concat(e, "Font Awesome fontawesome.com "), e;
}
var M1 = {
  replace: function(e) {
    var n = e[0];
    if (n.parentNode)
      if (e[1].forEach(function(r) {
        n.parentNode.insertBefore(s4(r), n);
      }), n.getAttribute(q) === null && v.keepOriginalSource) {
        var t = b.createComment(M3(n));
        n.parentNode.replaceChild(t, n);
      } else
        n.remove();
  },
  nest: function(e) {
    var n = e[0], t = e[1];
    if (~n2(n).indexOf(v.replacementClass))
      return M1.replace(e);
    var r = new RegExp("".concat(v.cssPrefix, "-.*"));
    if (delete t[0].attributes.id, t[0].attributes.class) {
      var c = t[0].attributes.class.split(" ").reduce(function(o, s) {
        return s === v.replacementClass || s.match(r) ? o.toSvg.push(s) : o.toNode.push(s), o;
      }, {
        toNode: [],
        toSvg: []
      });
      t[0].attributes.class = c.toSvg.join(" "), c.toNode.length === 0 ? n.removeAttribute("class") : n.setAttribute("class", c.toNode.join(" "));
    }
    var i = t.map(function(o) {
      return u1(o);
    }).join(`
`);
    n.setAttribute(q, ""), n.innerHTML = i;
  }
};
function C2(a) {
  a();
}
function l4(a, e) {
  var n = typeof e == "function" ? e : H1;
  if (a.length === 0)
    n();
  else {
    var t = C2;
    v.mutateApproach === C4 && (t = R.requestAnimationFrame || C2), t(function() {
      var r = z3(), c = s2.begin("mutate");
      a.map(r), c(), n();
    });
  }
}
var l2 = !1;
function f4() {
  l2 = !0;
}
function B1() {
  l2 = !1;
}
var V1 = null;
function k2(a) {
  if (h2 && v.observeMutations) {
    var e = a.treeCallback, n = e === void 0 ? H1 : e, t = a.nodeCallback, r = t === void 0 ? H1 : t, c = a.pseudoElementsCallback, i = c === void 0 ? H1 : c, o = a.observeMutationsRoot, s = o === void 0 ? b : o;
    V1 = new h2(function(f) {
      if (!l2) {
        var l = D();
        a1(f).forEach(function(m) {
          if (m.type === "childList" && m.addedNodes.length > 0 && !V2(m.addedNodes[0]) && (v.searchPseudoElements && i(m.target), n(m.target)), m.type === "attributes" && m.target.parentNode && v.searchPseudoElements && i(m.target.parentNode), m.type === "attributes" && V2(m.target) && ~O4.indexOf(m.attributeName))
            if (m.attributeName === "class" && g3(m.target)) {
              var d = N1(n2(m.target)), h = d.prefix, M = d.iconName;
              m.target.setAttribute(J1, h || l), M && m.target.setAttribute(a2, M);
            } else
              b3(m.target) && r(m.target);
        });
      }
    }), $ && V1.observe(s, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function x3() {
  V1 && V1.disconnect();
}
function L3(a) {
  var e = a.getAttribute("style"), n = [];
  return e && (n = e.split(";").reduce(function(t, r) {
    var c = r.split(":"), i = c[0], o = c.slice(1);
    return i && o.length > 0 && (t[i] = o.join(":").trim()), t;
  }, {})), n;
}
function V3(a) {
  var e = a.getAttribute("data-prefix"), n = a.getAttribute("data-icon"), t = a.innerText !== void 0 ? a.innerText.trim() : "", r = N1(n2(a));
  return r.prefix || (r.prefix = D()), e && n && (r.prefix = e, r.iconName = n), r.iconName && r.prefix || (r.prefix && t.length > 0 && (r.iconName = n3(r.prefix, a.innerText) || c2(r.prefix, D1(a.innerText))), !r.iconName && v.autoFetchSvg && a.firstChild && a.firstChild.nodeType === Node.TEXT_NODE && (r.iconName = a.firstChild.data)), r;
}
function C3(a) {
  var e = a1(a.attributes).reduce(function(r, c) {
    return r.name !== "class" && r.name !== "style" && (r[c.name] = c.value), r;
  }, {}), n = a.getAttribute("title"), t = a.getAttribute("data-fa-title-id");
  return v.autoA11y && (n ? e["aria-labelledby"] = "".concat(v.replacementClass, "-title-").concat(t || s1()) : (e["aria-hidden"] = "true", e.focusable = "false")), e;
}
function k3() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: S,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function w2(a) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, n = V3(a), t = n.iconName, r = n.prefix, c = n.rest, i = C3(a), o = j1("parseNodeAttributes", {}, a), s = e.styleParser ? L3(a) : [];
  return u({
    iconName: t,
    title: a.getAttribute("title"),
    titleId: a.getAttribute("data-fa-title-id"),
    prefix: r,
    transform: S,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: c,
      styles: s,
      attributes: i
    }
  }, o);
}
var w3 = A.styles;
function u4(a) {
  var e = v.autoReplaceSvg === "nest" ? w2(a, {
    styleParser: !1
  }) : w2(a);
  return ~e.extra.classes.indexOf(B2) ? E("generateLayersText", a, e) : E("generateSvgReplacementMutation", a, e);
}
var F = /* @__PURE__ */ new Set();
e2.map(function(a) {
  F.add("fa-".concat(a));
});
Object.keys(r1[g]).map(F.add.bind(F));
Object.keys(r1[z]).map(F.add.bind(F));
F = l1(F);
function N2(a) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!$)
    return Promise.resolve();
  var n = b.documentElement.classList, t = function(m) {
    return n.add("".concat(g2, "-").concat(m));
  }, r = function(m) {
    return n.remove("".concat(g2, "-").concat(m));
  }, c = v.autoFetchSvg ? F : e2.map(function(l) {
    return "fa-".concat(l);
  }).concat(Object.keys(w3));
  c.includes("fa") || c.push("fa");
  var i = [".".concat(B2, ":not([").concat(q, "])")].concat(c.map(function(l) {
    return ".".concat(l, ":not([").concat(q, "])");
  })).join(", ");
  if (i.length === 0)
    return Promise.resolve();
  var o = [];
  try {
    o = a1(a.querySelectorAll(i));
  } catch {
  }
  if (o.length > 0)
    t("pending"), r("complete");
  else
    return Promise.resolve();
  var s = s2.begin("onTree"), f = o.reduce(function(l, m) {
    try {
      var d = u4(m);
      d && l.push(d);
    } catch (h) {
      q2 || h.name === "MissingIcon" && console.error(h);
    }
    return l;
  }, []);
  return new Promise(function(l, m) {
    Promise.all(f).then(function(d) {
      l4(d, function() {
        t("active"), t("complete"), r("pending"), typeof e == "function" && e(), s(), l();
      });
    }).catch(function(d) {
      s(), m(d);
    });
  });
}
function N3(a) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  u4(a).then(function(n) {
    n && l4([n], e);
  });
}
function A3(a) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = (e || {}).icon ? e : Y1(e || {}), r = n.mask;
    return r && (r = (r || {}).icon ? r : Y1(r || {})), a(t, u(u({}, n), {}, {
      mask: r
    }));
  };
}
var S3 = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.transform, r = t === void 0 ? S : t, c = n.symbol, i = c === void 0 ? !1 : c, o = n.mask, s = o === void 0 ? null : o, f = n.maskId, l = f === void 0 ? null : f, m = n.title, d = m === void 0 ? null : m, h = n.titleId, M = h === void 0 ? null : h, C = n.classes, y = C === void 0 ? [] : C, k = n.attributes, H = k === void 0 ? {} : k, x = n.styles, w = x === void 0 ? {} : x;
  if (e) {
    var V = e.prefix, j = e.iconName, Y = e.icon;
    return A1(u({
      type: "icon"
    }, e), function() {
      return B("beforeDOMElementCreation", {
        iconDefinition: e,
        params: n
      }), v.autoA11y && (d ? H["aria-labelledby"] = "".concat(v.replacementClass, "-title-").concat(M || s1()) : (H["aria-hidden"] = "true", H.focusable = "false")), o2({
        icons: {
          main: U1(Y),
          mask: s ? U1(s.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: V,
        iconName: j,
        transform: u(u({}, S), r),
        symbol: i,
        title: d,
        maskId: l,
        titleId: M,
        extra: {
          attributes: H,
          styles: w,
          classes: y
        }
      });
    });
  }
}, P3 = {
  mixout: function() {
    return {
      icon: A3(S3)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.treeCallback = N2, n.nodeCallback = N3, n;
      }
    };
  },
  provides: function(e) {
    e.i2svg = function(n) {
      var t = n.node, r = t === void 0 ? b : t, c = n.callback, i = c === void 0 ? function() {
      } : c;
      return N2(r, i);
    }, e.generateSvgReplacementMutation = function(n, t) {
      var r = t.iconName, c = t.title, i = t.titleId, o = t.prefix, s = t.transform, f = t.symbol, l = t.mask, m = t.maskId, d = t.extra;
      return new Promise(function(h, M) {
        Promise.all([W1(r, o), l.iconName ? W1(l.iconName, l.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(C) {
          var y = Q1(C, 2), k = y[0], H = y[1];
          h([n, o2({
            icons: {
              main: k,
              mask: H
            },
            prefix: o,
            iconName: r,
            transform: s,
            symbol: f,
            maskId: m,
            title: c,
            titleId: i,
            extra: d,
            watchable: !0
          })]);
        }).catch(M);
      });
    }, e.generateAbstractIcon = function(n) {
      var t = n.children, r = n.attributes, c = n.main, i = n.transform, o = n.styles, s = k1(o);
      s.length > 0 && (r.style = s);
      var f;
      return t2(i) && (f = E("generateAbstractTransformGrouping", {
        main: c,
        transform: i,
        containerWidth: c.width,
        iconWidth: c.width
      })), t.push(f || c.icon), {
        children: t,
        attributes: r
      };
    };
  }
}, O3 = {
  mixout: function() {
    return {
      layer: function(n) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.classes, c = r === void 0 ? [] : r;
        return A1({
          type: "layer"
        }, function() {
          B("beforeDOMElementCreation", {
            assembler: n,
            params: t
          });
          var i = [];
          return n(function(o) {
            Array.isArray(o) ? o.map(function(s) {
              i = i.concat(s.abstract);
            }) : i = i.concat(o.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(v.cssPrefix, "-layers")].concat(l1(c)).join(" ")
            },
            children: i
          }];
        });
      }
    };
  }
}, E3 = {
  mixout: function() {
    return {
      counter: function(n) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.title, c = r === void 0 ? null : r, i = t.classes, o = i === void 0 ? [] : i, s = t.attributes, f = s === void 0 ? {} : s, l = t.styles, m = l === void 0 ? {} : l;
        return A1({
          type: "counter",
          content: n
        }, function() {
          return B("beforeDOMElementCreation", {
            content: n,
            params: t
          }), v3({
            content: n.toString(),
            title: c,
            extra: {
              attributes: f,
              styles: m,
              classes: ["".concat(v.cssPrefix, "-layers-counter")].concat(l1(o))
            }
          });
        });
      }
    };
  }
}, $3 = {
  mixout: function() {
    return {
      text: function(n) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.transform, c = r === void 0 ? S : r, i = t.title, o = i === void 0 ? null : i, s = t.classes, f = s === void 0 ? [] : s, l = t.attributes, m = l === void 0 ? {} : l, d = t.styles, h = d === void 0 ? {} : d;
        return A1({
          type: "text",
          content: n
        }, function() {
          return B("beforeDOMElementCreation", {
            content: n,
            params: t
          }), x2({
            content: n,
            transform: u(u({}, S), c),
            title: o,
            extra: {
              attributes: m,
              styles: h,
              classes: ["".concat(v.cssPrefix, "-layers-text")].concat(l1(f))
            }
          });
        });
      }
    };
  },
  provides: function(e) {
    e.generateLayersText = function(n, t) {
      var r = t.title, c = t.transform, i = t.extra, o = null, s = null;
      if (Y2) {
        var f = parseInt(getComputedStyle(n).fontSize, 10), l = n.getBoundingClientRect();
        o = l.width / f, s = l.height / f;
      }
      return v.autoA11y && !r && (i.attributes["aria-hidden"] = "true"), Promise.resolve([n, x2({
        content: n.innerHTML,
        width: o,
        height: s,
        transform: c,
        title: r,
        extra: i,
        watchable: !0
      })]);
    };
  }
}, I3 = new RegExp('"', "ug"), A2 = [1105920, 1112319];
function T3(a) {
  var e = a.replace(I3, ""), n = K4(e, 0), t = n >= A2[0] && n <= A2[1], r = e.length === 2 ? e[0] === e[1] : !1;
  return {
    value: D1(r ? e[0] : e),
    isSecondary: t || r
  };
}
function S2(a, e) {
  var n = "".concat(V4).concat(e.replace(":", "-"));
  return new Promise(function(t, r) {
    if (a.getAttribute(n) !== null)
      return t();
    var c = a1(a.children), i = c.filter(function(Y) {
      return Y.getAttribute(R1) === e;
    })[0], o = R.getComputedStyle(a, e), s = o.getPropertyValue("font-family").match(A4), f = o.getPropertyValue("font-weight"), l = o.getPropertyValue("content");
    if (i && !s)
      return a.removeChild(i), t();
    if (s && l !== "none" && l !== "") {
      var m = o.getPropertyValue("content"), d = ~["Sharp"].indexOf(s[2]) ? z : g, h = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(s[2]) ? c1[d][s[2].toLowerCase()] : S4[d][f], M = T3(m), C = M.value, y = M.isSecondary, k = s[0].startsWith("FontAwesome"), H = c2(h, C), x = H;
      if (k) {
        var w = t3(C);
        w.iconName && w.prefix && (H = w.iconName, h = w.prefix);
      }
      if (H && !y && (!i || i.getAttribute(J1) !== h || i.getAttribute(a2) !== x)) {
        a.setAttribute(n, x), i && a.removeChild(i);
        var V = k3(), j = V.extra;
        j.attributes[R1] = e, W1(H, h).then(function(Y) {
          var S1 = o2(u(u({}, V), {}, {
            icons: {
              main: Y,
              mask: i2()
            },
            prefix: h,
            iconName: x,
            extra: j,
            watchable: !0
          })), I = b.createElement("svg");
          e === "::before" ? a.insertBefore(I, a.firstChild) : a.appendChild(I), I.outerHTML = S1.map(function(p4) {
            return u1(p4);
          }).join(`
`), a.removeAttribute(n), t();
        }).catch(r);
      } else
        t();
    } else
      t();
  });
}
function _3(a) {
  return Promise.all([S2(a, "::before"), S2(a, "::after")]);
}
function R3(a) {
  return a.parentNode !== document.head && !~k4.indexOf(a.tagName.toUpperCase()) && !a.getAttribute(R1) && (!a.parentNode || a.parentNode.tagName !== "svg");
}
function P2(a) {
  if ($)
    return new Promise(function(e, n) {
      var t = a1(a.querySelectorAll("*")).filter(R3).map(_3), r = s2.begin("searchPseudoElements");
      f4(), Promise.all(t).then(function() {
        r(), B1(), e();
      }).catch(function() {
        r(), B1(), n();
      });
    });
}
var D3 = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.pseudoElementsCallback = P2, n;
      }
    };
  },
  provides: function(e) {
    e.pseudoElements2svg = function(n) {
      var t = n.node, r = t === void 0 ? b : t;
      v.searchPseudoElements && P2(r);
    };
  }
}, O2 = !1, F3 = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          f4(), O2 = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        k2(j1("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        x3();
      },
      watch: function(n) {
        var t = n.observeMutationsRoot;
        O2 ? B1() : k2(j1("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
}, E2 = function(e) {
  var n = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce(function(t, r) {
    var c = r.toLowerCase().split("-"), i = c[0], o = c.slice(1).join("-");
    if (i && o === "h")
      return t.flipX = !0, t;
    if (i && o === "v")
      return t.flipY = !0, t;
    if (o = parseFloat(o), isNaN(o))
      return t;
    switch (i) {
      case "grow":
        t.size = t.size + o;
        break;
      case "shrink":
        t.size = t.size - o;
        break;
      case "left":
        t.x = t.x - o;
        break;
      case "right":
        t.x = t.x + o;
        break;
      case "up":
        t.y = t.y - o;
        break;
      case "down":
        t.y = t.y + o;
        break;
      case "rotate":
        t.rotate = t.rotate + o;
        break;
    }
    return t;
  }, n);
}, j3 = {
  mixout: function() {
    return {
      parse: {
        transform: function(n) {
          return E2(n);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(n, t) {
        var r = t.getAttribute("data-fa-transform");
        return r && (n.transform = E2(r)), n;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractTransformGrouping = function(n) {
      var t = n.main, r = n.transform, c = n.containerWidth, i = n.iconWidth, o = {
        transform: "translate(".concat(c / 2, " 256)")
      }, s = "translate(".concat(r.x * 32, ", ").concat(r.y * 32, ") "), f = "scale(".concat(r.size / 16 * (r.flipX ? -1 : 1), ", ").concat(r.size / 16 * (r.flipY ? -1 : 1), ") "), l = "rotate(".concat(r.rotate, " 0 0)"), m = {
        transform: "".concat(s, " ").concat(f, " ").concat(l)
      }, d = {
        transform: "translate(".concat(i / 2 * -1, " -256)")
      }, h = {
        outer: o,
        inner: m,
        path: d
      };
      return {
        tag: "g",
        attributes: u({}, h.outer),
        children: [{
          tag: "g",
          attributes: u({}, h.inner),
          children: [{
            tag: t.icon.tag,
            children: t.icon.children,
            attributes: u(u({}, t.icon.attributes), h.path)
          }]
        }]
      };
    };
  }
}, $1 = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function $2(a) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return a.attributes && (a.attributes.fill || e) && (a.attributes.fill = "black"), a;
}
function Y3(a) {
  return a.tag === "g" ? a.children : [a];
}
var U3 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, t) {
        var r = t.getAttribute("data-fa-mask"), c = r ? N1(r.split(" ").map(function(i) {
          return i.trim();
        })) : i2();
        return c.prefix || (c.prefix = D()), n.mask = c, n.maskId = t.getAttribute("data-fa-mask-id"), n;
      }
    };
  },
  provides: function(e) {
    e.generateAbstractMask = function(n) {
      var t = n.children, r = n.attributes, c = n.main, i = n.mask, o = n.maskId, s = n.transform, f = c.width, l = c.icon, m = i.width, d = i.icon, h = j4({
        transform: s,
        containerWidth: m,
        iconWidth: f
      }), M = {
        tag: "rect",
        attributes: u(u({}, $1), {}, {
          fill: "white"
        })
      }, C = l.children ? {
        children: l.children.map($2)
      } : {}, y = {
        tag: "g",
        attributes: u({}, h.inner),
        children: [$2(u({
          tag: l.tag,
          attributes: u(u({}, l.attributes), h.path)
        }, C))]
      }, k = {
        tag: "g",
        attributes: u({}, h.outer),
        children: [y]
      }, H = "mask-".concat(o || s1()), x = "clip-".concat(o || s1()), w = {
        tag: "mask",
        attributes: u(u({}, $1), {}, {
          id: H,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [M, k]
      }, V = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: x
          },
          children: Y3(d)
        }, w]
      };
      return t.push(V, {
        tag: "rect",
        attributes: u({
          fill: "currentColor",
          "clip-path": "url(#".concat(x, ")"),
          mask: "url(#".concat(H, ")")
        }, $1)
      }), {
        children: t,
        attributes: r
      };
    };
  }
}, W3 = {
  provides: function(e) {
    var n = !1;
    R.matchMedia && (n = R.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      var t = [], r = {
        fill: "currentColor"
      }, c = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      t.push({
        tag: "path",
        attributes: u(u({}, r), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var i = u(u({}, c), {}, {
        attributeName: "opacity"
      }), o = {
        tag: "circle",
        attributes: u(u({}, r), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return n || o.children.push({
        tag: "animate",
        attributes: u(u({}, c), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: u(u({}, i), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), t.push(o), t.push({
        tag: "path",
        attributes: u(u({}, r), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: n ? [] : [{
          tag: "animate",
          attributes: u(u({}, i), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), n || t.push({
        tag: "path",
        attributes: u(u({}, r), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: u(u({}, i), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: t
      };
    };
  }
}, q3 = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, t) {
        var r = t.getAttribute("data-fa-symbol"), c = r === null ? !1 : r === "" ? !0 : r;
        return n.symbol = c, n;
      }
    };
  }
}, B3 = [W4, P3, O3, E3, $3, D3, F3, j3, U3, W3, q3];
i3(B3, {
  mixoutsTo: N
});
N.noAuto;
N.config;
var X3 = N.library;
N.dom;
var X1 = N.parse;
N.findIconDefinition;
N.toHtml;
var G3 = N.icon;
N.layer;
N.text;
N.counter;
function I2(a, e) {
  var n = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(a);
    e && (t = t.filter(function(r) {
      return Object.getOwnPropertyDescriptor(a, r).enumerable;
    })), n.push.apply(n, t);
  }
  return n;
}
function _(a) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? I2(Object(n), !0).forEach(function(t) {
      K(a, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(n)) : I2(Object(n)).forEach(function(t) {
      Object.defineProperty(a, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return a;
}
function C1(a) {
  "@babel/helpers - typeof";
  return C1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, C1(a);
}
function K(a, e, n) {
  return e in a ? Object.defineProperty(a, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[e] = n, a;
}
function K3(a, e) {
  if (a == null)
    return {};
  var n = {}, t = Object.keys(a), r, c;
  for (c = 0; c < t.length; c++)
    r = t[c], !(e.indexOf(r) >= 0) && (n[r] = a[r]);
  return n;
}
function Q3(a, e) {
  if (a == null)
    return {};
  var n = K3(a, e), t, r;
  if (Object.getOwnPropertySymbols) {
    var c = Object.getOwnPropertySymbols(a);
    for (r = 0; r < c.length; r++)
      t = c[r], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(a, t) && (n[t] = a[t]);
  }
  return n;
}
function G1(a) {
  return Z3(a) || J3(a) || aa(a) || ea();
}
function Z3(a) {
  if (Array.isArray(a))
    return K1(a);
}
function J3(a) {
  if (typeof Symbol < "u" && a[Symbol.iterator] != null || a["@@iterator"] != null)
    return Array.from(a);
}
function aa(a, e) {
  if (a) {
    if (typeof a == "string")
      return K1(a, e);
    var n = Object.prototype.toString.call(a).slice(8, -1);
    if (n === "Object" && a.constructor && (n = a.constructor.name), n === "Map" || n === "Set")
      return Array.from(a);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return K1(a, e);
  }
}
function K1(a, e) {
  (e == null || e > a.length) && (e = a.length);
  for (var n = 0, t = new Array(e); n < e; n++)
    t[n] = a[n];
  return t;
}
function ea() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function na(a) {
  var e, n = a.beat, t = a.fade, r = a.beatFade, c = a.bounce, i = a.shake, o = a.flash, s = a.spin, f = a.spinPulse, l = a.spinReverse, m = a.pulse, d = a.fixedWidth, h = a.inverse, M = a.border, C = a.listItem, y = a.flip, k = a.size, H = a.rotation, x = a.pull, w = (e = {
    "fa-beat": n,
    "fa-fade": t,
    "fa-beat-fade": r,
    "fa-bounce": c,
    "fa-shake": i,
    "fa-flash": o,
    "fa-spin": s,
    "fa-spin-reverse": l,
    "fa-spin-pulse": f,
    "fa-pulse": m,
    "fa-fw": d,
    "fa-inverse": h,
    "fa-border": M,
    "fa-li": C,
    "fa-flip": y === !0,
    "fa-flip-horizontal": y === "horizontal" || y === "both",
    "fa-flip-vertical": y === "vertical" || y === "both"
  }, K(e, "fa-".concat(k), typeof k < "u" && k !== null), K(e, "fa-rotate-".concat(H), typeof H < "u" && H !== null && H !== 0), K(e, "fa-pull-".concat(x), typeof x < "u" && x !== null), K(e, "fa-swap-opacity", a.swapOpacity), e);
  return Object.keys(w).map(function(V) {
    return w[V] ? V : null;
  }).filter(function(V) {
    return V;
  });
}
function ta(a) {
  return a = a - 0, a === a;
}
function m4(a) {
  return ta(a) ? a : (a = a.replace(/[\-_\s]+(.)?/g, function(e, n) {
    return n ? n.toUpperCase() : "";
  }), a.substr(0, 1).toLowerCase() + a.substr(1));
}
var ra = ["style"];
function ca(a) {
  return a.charAt(0).toUpperCase() + a.slice(1);
}
function ia(a) {
  return a.split(";").map(function(e) {
    return e.trim();
  }).filter(function(e) {
    return e;
  }).reduce(function(e, n) {
    var t = n.indexOf(":"), r = m4(n.slice(0, t)), c = n.slice(t + 1).trim();
    return r.startsWith("webkit") ? e[ca(r)] = c : e[r] = c, e;
  }, {});
}
function v4(a, e) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof e == "string")
    return e;
  var t = (e.children || []).map(function(s) {
    return v4(a, s);
  }), r = Object.keys(e.attributes || {}).reduce(function(s, f) {
    var l = e.attributes[f];
    switch (f) {
      case "class":
        s.attrs.className = l, delete e.attributes.class;
        break;
      case "style":
        s.attrs.style = ia(l);
        break;
      default:
        f.indexOf("aria-") === 0 || f.indexOf("data-") === 0 ? s.attrs[f.toLowerCase()] = l : s.attrs[m4(f)] = l;
    }
    return s;
  }, {
    attrs: {}
  }), c = n.style, i = c === void 0 ? {} : c, o = Q3(n, ra);
  return r.attrs.style = _(_({}, r.attrs.style), i), a.apply(void 0, [e.tag, _(_({}, r.attrs), o)].concat(G1(t)));
}
var d4 = !1;
try {
  d4 = process.env.NODE_ENV === "production";
} catch {
}
function oa() {
  if (!d4 && console && typeof console.error == "function") {
    var a;
    (a = console).error.apply(a, arguments);
  }
}
function T2(a) {
  if (a && C1(a) === "object" && a.prefix && a.iconName && a.icon)
    return a;
  if (X1.icon)
    return X1.icon(a);
  if (a === null)
    return null;
  if (a && C1(a) === "object" && a.prefix && a.iconName)
    return a;
  if (Array.isArray(a) && a.length === 2)
    return {
      prefix: a[0],
      iconName: a[1]
    };
  if (typeof a == "string")
    return {
      prefix: "fas",
      iconName: a
    };
}
function I1(a, e) {
  return Array.isArray(e) && e.length > 0 || !Array.isArray(e) && e ? K({}, a, e) : {};
}
var J = /* @__PURE__ */ _2.forwardRef(function(a, e) {
  var n = a.icon, t = a.mask, r = a.symbol, c = a.className, i = a.title, o = a.titleId, s = a.maskId, f = T2(n), l = I1("classes", [].concat(G1(na(a)), G1(c.split(" ")))), m = I1("transform", typeof a.transform == "string" ? X1.transform(a.transform) : a.transform), d = I1("mask", T2(t)), h = G3(f, _(_(_(_({}, l), m), d), {}, {
    symbol: r,
    title: i,
    titleId: o,
    maskId: s
  }));
  if (!h)
    return oa("Could not find icon", f), null;
  var M = h.abstract, C = {
    ref: e
  };
  return Object.keys(a).forEach(function(y) {
    J.defaultProps.hasOwnProperty(y) || (C[y] = a[y]);
  }), sa(M[0], C);
});
J.displayName = "FontAwesomeIcon";
J.propTypes = {
  beat: p.bool,
  border: p.bool,
  beatFade: p.bool,
  bounce: p.bool,
  className: p.string,
  fade: p.bool,
  flash: p.bool,
  mask: p.oneOfType([p.object, p.array, p.string]),
  maskId: p.string,
  fixedWidth: p.bool,
  inverse: p.bool,
  flip: p.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: p.oneOfType([p.object, p.array, p.string]),
  listItem: p.bool,
  pull: p.oneOf(["right", "left"]),
  pulse: p.bool,
  rotation: p.oneOf([0, 90, 180, 270]),
  shake: p.bool,
  size: p.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: p.bool,
  spinPulse: p.bool,
  spinReverse: p.bool,
  symbol: p.oneOfType([p.bool, p.string]),
  title: p.string,
  titleId: p.string,
  transform: p.oneOfType([p.string, p.object]),
  swapOpacity: p.bool
};
J.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var sa = v4.bind(null, _2.createElement), la = {
  prefix: "fat",
  iconName: "circle-minus",
  icon: [512, 512, ["minus-circle"], "f056", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H352c4.4 0 8-3.6 8-8s-3.6-8-8-8H160z"]
}, fa = {
  prefix: "fat",
  iconName: "message-bot",
  icon: [640, 512, [], "e3b8", "M224 400c8.8 0 16 7.2 16 16v80l123.7-92.8c2.8-2.1 6.1-3.2 9.6-3.2H480c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H160c-26.5 0-48 21.5-48 48V352c0 26.5 21.5 48 48 48h64zM96 64c0-35.3 28.7-64 64-64H480c35.3 0 64 28.7 64 64V184h33c3.6-13.8 16.1-24 31-24c17.7 0 32 14.3 32 32s-14.3 32-32 32c-14.9 0-27.4-10.2-31-24H544V352c0 35.3-28.7 64-64 64H373.3L249.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V432 416H208 160c-35.3 0-64-28.7-64-64V200H63c-3.6 13.8-16.1 24-31 24c-17.7 0-32-14.3-32-32s14.3-32 32-32c14.9 0 27.4 10.2 31 24H96V64zM32 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm592-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM176 96c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm-32 16c0-17.7 14.3-32 32-32H464c17.7 0 32 14.3 32 32V272c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V112zm80 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm40 24a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zm128 0a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm24 40a40 40 0 1 1 0-80 40 40 0 1 1 0 80z"]
}, ua = {
  prefix: "fat",
  iconName: "message-exclamation",
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", "M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM256 80c-4.4 0-8 3.6-8 8V248c0 4.4 3.6 8 8 8s8-3.6 8-8V88c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
}, ma = {
  prefix: "fat",
  iconName: "chevrons-left",
  icon: [512, 512, ["chevron-double-left"], "f323", "M50.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L67.3 256 277.7 45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-216 216zm408-216l-216 216c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L259.3 256 469.7 45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0z"]
}, va = {
  prefix: "fat",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M395 25.9c12.5-12.5 32.8-12.5 45.3 0l45.8 45.8c12.5 12.5 12.5 32.8 0 45.3l-66.9 66.9L328.1 92.8 395 25.9zm-78.2 78.2l91.1 91.1L164.7 438.4c-1.5 1.5-3.1 3-4.7 4.4V408c0-4.4-3.6-8-8-8H112V360c0-4.4-3.6-8-8-8H69.2c1.4-1.6 2.9-3.2 4.4-4.7L316.8 104.1zM51.4 384.7c1.7-5.8 4-11.4 6.8-16.7H96v40c0 4.4 3.6 8 8 8h40v37.7c-5.3 2.8-10.9 5.1-16.7 6.8L19.8 492.2 51.4 384.7zm400.1-370c-18.7-18.7-49.1-18.7-67.9 0L62.3 336C50 348.3 41 363.5 36.1 380.2L.3 501.7c-.8 2.8-.1 5.8 2 7.9s5.1 2.8 7.9 2l121.6-35.8c16.7-4.9 31.9-13.9 44.2-26.2L497.4 128.3c18.7-18.7 18.7-49.1 0-67.9L451.5 14.6zM317.7 173.1c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-144 144c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l144-144z"]
}, da = va, pa = {
  prefix: "fat",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-4.4 0-8 3.6-8 8V296c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
}, ha = {
  prefix: "fat",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M460.3 39.6l12.1 12.1c15.6 15.6 15.6 40.9 0 56.6L440 140.7 371.3 72l32.4-32.4c15.6-15.6 40.9-15.6 56.6 0zM175.4 267.9L360 83.3 428.7 152 244.1 336.6c-5.3 5.3-12 9-19.3 10.7l-78.1 18 18-78.1c1.7-7.3 5.4-14 10.7-19.3zm217-239.6L164.1 256.6c-7.4 7.4-12.6 16.8-15 27l-20.9 90.6c-.6 2.7 .2 5.5 2.1 7.5s4.8 2.8 7.5 2.1l90.6-20.9c10.2-2.4 19.6-7.5 27-15L483.7 119.6c21.9-21.9 21.9-57.3 0-79.2L471.6 28.3c-21.9-21.9-57.3-21.9-79.2 0zM72 64C32.2 64 0 96.2 0 136V440c0 39.8 32.2 72 72 72H376c39.8 0 72-32.2 72-72V296c0-4.4-3.6-8-8-8s-8 3.6-8 8V440c0 30.9-25.1 56-56 56H72c-30.9 0-56-25.1-56-56V136c0-30.9 25.1-56 56-56H216c4.4 0 8-3.6 8-8s-3.6-8-8-8H72z"]
}, ga = {
  prefix: "fat",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M250.3 114.3c3.1-3.1 8.2-3.1 11.3 0l216 216c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L256 131.3 45.7 341.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l216-216z"]
}, ba = {
  prefix: "fat",
  iconName: "user-helmet-safety",
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", "M200 24V88c0 4.4-3.6 8-8 8s-8-3.6-8-8V38.8C137.4 55.3 104 99.8 104 152v8H344v-8c0-52.2-33.4-96.7-80-113.2V88c0 4.4-3.6 8-8 8s-8-3.6-8-8V24c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8zm-16 0c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24V22c55.6 17.1 96 68.8 96 130v8l16 0c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8s3.6-8 8-8l16 0v-8c0-61.2 40.4-112.9 96-130v2zm40 296c-65.3 0-119.1-48.9-127-112h16.1c7.8 54.3 54.4 96 110.9 96s103.1-41.7 110.9-96H351c-7.9 63.1-61.7 112-127 112zm-89.6 48C69 368 16 421 16 486.4c0 5.3 4.3 9.6 9.6 9.6H422.4c5.3 0 9.6-4.3 9.6-9.6C432 421 379 368 313.6 368H134.4zM0 486.4C0 412.2 60.2 352 134.4 352H313.6C387.8 352 448 412.2 448 486.4c0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z"]
}, za = {
  prefix: "fat",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M432 40c-4.4 0-8 3.6-8 8v56H368c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v56c0 4.4 3.6 8 8 8s8-3.6 8-8V120h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V48c0-4.4-3.6-8-8-8zm0 288c-4.4 0-8 3.6-8 8v56H368c-4.4 0-8 3.6-8 8s3.6 8 8 8h56v56c0 4.4 3.6 8 8 8s8-3.6 8-8V408h56c4.4 0 8-3.6 8-8s-3.6-8-8-8H440V336c0-4.4-3.6-8-8-8zM130.1 201.9c3.5-1.6 6.2-4.4 7.8-7.8L190.6 80l52.7 114.1c1.6 3.5 4.4 6.2 7.8 7.8l114.1 52.7L251 307.2c-3.5 1.6-6.2 4.4-7.8 7.8L190.6 429.1 137.9 315c-1.6-3.5-4.4-6.2-7.8-7.8L16 254.6l114.1-52.7zm75-128.6c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.4 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3z"]
}, ya = {
  prefix: "fat",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM357.7 197.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z"]
}, Ha = {
  prefix: "fat",
  iconName: "cloud-arrow-up",
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M522.7 220.8c3.4-8.9 5.3-18.6 5.3-28.8c0-44.2-35.8-80-80-80c-16.5 0-31.7 5-44.4 13.5c-3.7 2.5-8.2 3.3-12.5 2.3s-8-3.8-10.2-7.6C355.9 77 309.3 48 256 48c-79.5 0-144 64.5-144 144c0 2.5 .1 4.9 .2 7.3c.4 7.1-4 13.5-10.7 15.9C51.7 232.7 16 280.2 16 336c0 70.7 57.3 128 128 128H512c61.9 0 112-50.1 112-112c0-54.2-38.5-99.4-89.6-109.8c-4.6-.9-8.6-3.9-10.9-8s-2.6-9.1-.9-13.4zM256 32c53.6 0 101 26.3 130 66.7c3.1 4.3 6 8.8 8.7 13.4c3.5-2.4 7.2-4.5 11-6.4C418.5 99.5 432.8 96 448 96c53 0 96 43 96 96c0 6.6-.7 13-1.9 19.2c-1.1 5.3-2.6 10.5-4.5 15.4c5.3 1.1 10.5 2.5 15.5 4.2C603.6 247.9 640 295.7 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160zM226.3 274.3l88-88c3.1-3.1 8.2-3.1 11.3 0l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L328 211.3V408c0 4.4-3.6 8-8 8s-8-3.6-8-8V211.3l-74.3 74.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3z"]
}, Ma = {
  prefix: "fat",
  iconName: "triangle-person-digging",
  icon: [640, 512, ["construction"], "f85d", "M340.5 27.5C336.1 20.3 328.3 16 320 16s-16.1 4.4-20.5 11.5l-264 432c-4.5 7.4-4.7 16.7-.5 24.3S47.3 496 56 496H584.5c8.7 0 16.7-4.7 20.9-12.3l14 7.8C612.3 504.2 599 512 584.5 512H56c-14.5 0-27.8-7.8-34.9-20.4s-6.8-28.1 .8-40.4l264-432C293.1 7.3 306.1 0 320 0s26.9 7.2 34.1 19.1l264.5 432c7.6 12.3 7.9 27.8 .8 40.4l-14-7.8c4.2-7.6 4.1-16.9-.5-24.3L340.5 27.5zM432 334.2L380.9 416H483.1L432 334.2zm-39.5 33.1l26-41.6c6.3-10 20.9-10 27.1 0l51.1 81.8c6.7 10.7-1 24.5-13.6 24.5H380.9c-12.6 0-20.2-13.8-13.6-24.5l16.6-26.6L214.5 295.1c-8.9-4.5-14.5-13.6-14.5-23.5c0-7 2.8-13.7 7.7-18.6l6.6-6.6C223.5 237.2 236 232 249 232h4.1c24.4 0 46.2 15 54.9 37.7l26.2 68 58.3 29.5zM304 192a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM211.5 324.9l8 3.9 63 30.8c8.2 4 13.5 12.4 13.5 21.6V424c0 4.4-3.6 8-8 8s-8-3.6-8-8V381.2c0-3.1-1.7-5.8-4.5-7.2l-55-26.9-29 79.6c-1.5 4.2-6.1 6.3-10.3 4.8s-6.3-6.1-4.8-10.2l32-88 3-8.4zm14.1-67.2l-6.6 6.6c-1.9 1.9-3 4.6-3 7.3c0 3.9 2.2 7.5 5.7 9.3L312.9 327l-19.8-51.5c-6.4-16.6-22.3-27.5-40-27.5H249c-8.7 0-17.1 3.5-23.3 9.7z"]
}, xa = Ma, La = {
  prefix: "fat",
  iconName: "cloud-bolt",
  icon: [512, 512, [127785, "thunderstorm"], "f76c", "M402.1 138.2c-3.1-3.7-4.3-8.7-3.4-13.4c.8-4.1 1.3-8.4 1.3-12.8c0-35.3-28.7-64-64-64c-19.5 0-36.9 8.7-48.6 22.4c-3.5 4-8.7 6.1-13.9 5.5s-9.9-3.8-12.4-8.5C245 36.8 212.9 16 176 16c-53 0-96 43-96 96c0 6.1 .6 12.1 1.7 17.9c1.5 7.9-3.1 15.6-10.7 18.1C39 158.5 16 188.6 16 224c0 44.2 35.8 80 80 80h67.2l-20 16H96c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c37.1 0 70 18.1 90.4 45.9c3.3 4.5 6.2 9.2 8.8 14.1c3.6-4.2 7.6-8 12-11.4C300.7 38.2 317.6 32 336 32c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c4.9 0 9.8 .4 14.5 1.1c46.2 7 81.5 46.8 81.5 94.9c0 53-43 96-96 96H352 333.7l8-16H416c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.4 0-.9 0-1.3 0c-4.8 .1-9.5-2-12.6-5.8zM267.6 344.8L320 240 160 368h70.1c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L192 496 352 368H281.9c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6zm66.7-97.7L289.9 336l-8 16h17.9H352c6.8 0 12.9 4.3 15.1 10.7s.2 13.5-5.1 17.8l-160 128c-5.9 4.7-14.2 4.7-20.1-.1s-7.6-12.9-4.3-19.6L222.1 400l8-16H212.2 160c-6.8 0-12.8-4.3-15.1-10.7s-.2-13.5 5.1-17.8l160-128c5.9-4.7 14.2-4.7 20.1 .1s7.6 12.9 4.2 19.6z"]
}, Va = {
  prefix: "fat",
  iconName: "file-contract",
  icon: [384, 512, [], "f56c", "M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm8 64c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm0 64c-4.4 0-8 3.6-8 8s3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72zm53.6 185.8c.3-1.1 1.3-1.8 2.4-1.8s2.1 .7 2.4 1.8l20.7 75.9c1.7 6.1 7.2 10.3 13.5 10.3c5 0 9.6-2.7 12.1-7L201 350.4c2.3-3.9 6.5-6.4 11-6.4s8.8 2.4 11 6.4l16.8 29.5c7.1 12.5 20.4 20.2 34.7 20.2H320c4.4 0 8-3.6 8-8s-3.6-8-8-8H274.6c-8.6 0-16.6-4.6-20.8-12.1l-16.8-29.5c-5.1-8.9-14.6-14.5-24.9-14.5s-19.8 5.5-24.9 14.5l-21.9 38.3-19.4-71.1c-2.2-8-9.5-13.6-17.8-13.6s-15.6 5.6-17.8 13.6L94.7 366.3C91.9 376.8 82.4 384 71.6 384H64c-4.4 0-8 3.6-8 8s3.6 8 8 8h7.6c18 0 33.8-12.1 38.6-29.5l15.5-56.7z"]
}, Ca = {
  prefix: "fat",
  iconName: "telescope",
  icon: [576, 512, [128301], "e03e", "M439.1 21.9L349.9 73.4c-7.7 4.4-10.3 14.2-5.9 21.9l96 166.3c4.4 7.7 14.2 10.3 21.9 5.9l89.2-51.5c7.7-4.4 10.3-14.2 5.9-21.9L461 27.7c-4.4-7.7-14.2-10.3-21.9-5.9zM336.2 113.6L71.2 281.9c-7.2 4.6-9.6 14.1-5.3 21.5l54.5 94.5c4.3 7.5 13.8 10.2 21.5 6.1l97.5-52.7C229.7 338 224 321.7 224 304c0-44.2 35.8-80 80-80s80 35.8 80 80c0 24.9-11.4 47.1-29.2 61.8l60.5 134.9c1.8 4 0 8.8-4 10.6s-8.8 0-10.6-4L341.3 374.8c-11.1 5.9-23.8 9.2-37.3 9.2s-26.2-3.3-37.3-9.2L207.3 507.3c-1.8 4-6.5 5.8-10.6 4s-5.8-6.5-4-10.6l60.5-134.9c-.9-.8-1.8-1.5-2.7-2.4L149.5 418c-15.2 8.2-34.3 2.9-42.9-12.1L52 311.4c-8.6-14.9-3.9-33.8 10.6-43L328.4 99.6c-6.2-14.6-.6-31.9 13.5-40.1L431.1 8C446.4-.8 466 4.4 474.8 19.7l96 166.3c8.8 15.3 3.6 34.9-11.7 43.7l-89.2 51.5c-15.3 8.8-34.9 3.6-43.7-11.7l-.5-.8-42.6 23.1c-.9-5.5-2.3-10.8-4.2-15.9l38.8-21L336.2 113.6zM304 368a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM55.9 318.2l8 13.9L19.8 357.5c-3.8 2.2-5.1 7.1-2.9 10.9l25.9 44.9c2.2 3.8 7.1 5.1 10.9 2.9l44.1-25.5 8 13.9L61.7 430.1c-11.5 6.6-26.2 2.7-32.8-8.8L3.1 376.4c-6.6-11.5-2.7-26.2 8.8-32.8l44.1-25.5z"]
}, ka = {
  prefix: "fat",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168-56c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L264 294.9V320c0 4.4-3.6 8-8 8s-8-3.6-8-8V290.5c0-2.7 1.4-5.2 3.6-6.7l54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H224c-22.1 0-40 17.9-40 40l0 6.5c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-6.5zm72 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
}, wa = {
  prefix: "fat",
  iconName: "pen",
  icon: [512, 512, [128394], "f304", "M395 25.9c12.5-12.5 32.8-12.5 45.3 0l45.8 45.8c12.5 12.5 12.5 32.8 0 45.3l-66.9 66.9L328.1 92.8 395 25.9zm-78.2 78.2l91.1 91.1L164.7 438.4c-10.4 10.4-23.3 18-37.4 22.2L19.8 492.2 51.4 384.7c4.2-14.1 11.8-27 22.2-37.4L316.8 104.1zM451.5 14.6c-18.7-18.7-49.1-18.7-67.9 0L62.3 336C50 348.3 41 363.5 36.1 380.2L.3 501.7c-.8 2.8-.1 5.8 2 7.9s5.1 2.8 7.9 2l121.6-35.8c16.7-4.9 31.9-13.9 44.2-26.2L497.4 128.3c18.7-18.7 18.7-49.1 0-67.9L451.5 14.6z"]
}, Na = {
  prefix: "fat",
  iconName: "scale-unbalanced",
  icon: [640, 512, ["balance-scale-left"], "f515", "M544.2 5.5c1.4 4.2-.9 8.7-5.1 10.1L384.6 67.1c-1.5 31.2-25.4 56.6-55.9 60.4V496h208c4.4 0 8 3.6 8 8s-3.6 8-8 8h-216c-4.4 0-8-3.6-8-8V127.5c-16.5-2.1-31.1-10.4-41.3-22.7L107.2 159.6c-4.2 1.4-8.7-.9-10.1-5.1s.9-8.7 5.1-10.1L262.6 90.9c-3.8-8.2-5.9-17.3-5.9-26.9c0-35.3 28.7-64 64-64c30.8 0 56.5 21.7 62.6 50.7L534.1 .4c4.2-1.4 8.7 .9 10.1 5.1zM52.7 464c20.5 19.2 47.1 32 75.7 32s55.2-12.8 75.7-32c20.3-19 33.1-43.1 35.8-64H16.9c2.7 20.9 15.5 44.9 35.8 64zm75.7-254.2L23.8 384H232.9L128.4 209.8zM251.8 384.4c3 5 4.7 10.7 4.1 16.4C250 452.2 195.2 512 128.4 512S6.7 452.2 .9 400.8c-.7-5.8 1.1-11.5 4.1-16.4L116.3 198.9c2.6-4.3 7.2-6.9 12.1-6.9s9.6 2.6 12.1 6.9L251.8 384.4zM400.9 272c2.7 20.9 15.5 44.9 35.8 64c20.5 19.2 47.1 32 75.7 32s55.2-12.8 75.7-32c20.3-19 33.1-43.1 35.8-64h-223zm6.9-16H616.9L512.4 81.8 407.8 256zM524.5 70.9L635.8 256.4c3 5 4.7 10.7 4.1 16.4C634 324.2 579.2 384 512.4 384s-121.7-59.8-127.5-111.2c-.7-5.8 1.1-11.5 4-16.4L500.3 70.9c2.6-4.3 7.2-6.9 12.1-6.9s9.6 2.6 12.1 6.9zM320.7 112a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
}, Aa = {
  prefix: "fat",
  iconName: "hand-holding-dollar",
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M296 32c0-4.4-3.6-8-8-8s-8 3.6-8 8V48.4c-8.4 .7-16.2 2.6-23 5.7c-12.4 5.6-21.9 15.4-24.2 28.8c-1.4 8.2-.6 15.4 2.4 21.8c3 6.3 7.8 11 13.2 14.7c10 6.8 23.7 10.9 35.9 14.6l1.7 .5c13.4 4 25 7.8 32.9 13.5c3.7 2.7 6.3 5.7 7.7 9c1.4 3.3 2.1 7.6 1.1 13.5c-1.4 8.2-6.5 14.1-15.1 17.8c-8.8 3.8-21.1 5-35.4 2.7c-7.1-1.2-19.2-5.3-28.8-8.5l0 0 0 0c-2.1-.7-4-1.4-5.7-1.9c-4.2-1.4-8.7 .9-10.1 5.1s.9 8.7 5.1 10.1c1.4 .5 3.1 1 5 1.7l0 0c9.4 3.2 23.4 8 32 9.4l0 0c1.8 .3 3.7 .5 5.5 .7V224c0 4.4 3.6 8 8 8s8-3.6 8-8V207.9c8.3-.5 16-2.1 22.7-5c12.6-5.4 22.1-15.4 24.5-29.7c1.5-8.5 .7-16-2.1-22.6c-2.9-6.6-7.5-11.6-13-15.5c-10.5-7.6-24.9-12-37.6-15.8l-.3-.1 0 0c-13.4-4-25-7.5-32.9-12.9c-3.8-2.6-6.3-5.3-7.7-8.3c-1.4-2.9-2.1-6.8-1.1-12.2c1.2-6.8 6.2-12.9 15.1-17c9-4.1 21.4-5.7 35.4-3.5c4.5 .7 18.5 3.4 22.9 4.6c4.3 1.1 8.7-1.4 9.8-5.7s-1.4-8.7-5.7-9.8c-5.2-1.4-19.8-4.2-24.6-4.9c-1.8-.3-3.7-.5-5.5-.7V32zM521.8 340.7c10.7-7.9 25.7-5.6 33.6 5.1s5.6 25.7-5.1 33.6L423.6 472.6C403 487.8 378.1 496 352.5 496H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L394.7 414.4c-1.4 1-3 1.6-4.7 1.6H268c-6.6 0-12-5.4-12-12s5.4-12 12-12h80c19.9 0 36-16.1 36-36s-16.1-36-36-36H193.7c-29.1 0-57.3 9.9-80 28L71 382.2c-1.4 1.1-3.2 1.8-5 1.8H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H66c5.4 0 10.7-1.9 15-5.3l42.7-34.2c19.9-15.9 44.5-24.5 70-24.5H348c11 0 20 9 20 20s-9 20-20 20H268c-15.5 0-28 12.5-28 28s12.5 28 28 28H389.9c5.1 0 10.1-1.6 14.2-4.7l117.6-86.6z"]
}, Sa = {
  prefix: "fat",
  iconName: "house-person-leave",
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", "M245.2 1.9c-3-2.6-7.4-2.6-10.4 0l-232 200c-3.3 2.9-3.7 7.9-.8 11.3s7.9 3.7 11.3 .8L64 170.3V360c0 30.9 25.1 56 56 56H314.2l16-16H120c-22.1 0-40-17.9-40-40V156.5L240 18.6 370.9 131.4c4.5-3.2 9.2-6.2 14.1-9L245.2 1.9zM224 184c4.4 0 8 3.6 8 8v64c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V192c0-4.4 3.6-8 8-8h64zm-64-16c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24V192c0-13.3-10.7-24-24-24H160zm297.1 19.3c-4.6-4-11-5.1-16.6-2.8c-1.1 .5-2.2 .9-3.4 1.4l-5.7 2.5c-21.6 9.6-37.9 28.3-44.4 51.1l-3.7 12.9c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8l3.7-12.9c9.1-31.9 31.9-58.1 62.2-71.6l5.7-2.5c18.8-8.3 39-12.6 59.6-12.6c38.1 0 72.5 22.9 87.1 58.1l16.5 39.7c1.1 2.6 2.9 4.9 5.2 6.6l25 18.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-28.5-21.4c-4.6-3.4-8.1-8-10.3-13.3l-10.2-24.5c-2.6-6.3-8.9-10.2-15.6-9.8s-12.6 5-14.5 11.5L500 300.8c-1.6 5.4-.2 11.2 3.6 15.3l49.5 54c3.6 3.9 6.2 8.7 7.5 13.9l23 92.1c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6l-22-88.1c-.6-2.6-1.9-5-3.7-6.9l-70.7-77.1c-11.1-12.1-15.2-29-11-44.8L462 203.4c1.6-5.9-.3-12.1-4.9-16.1zM528 16a36 36 0 1 1 0 72 36 36 0 1 1 0-72zM427.4 209c3.3-2.3 6.8-4.3 10.6-6l5.7-2.5c1-.4 1.9-.8 2.9-1.2l-1.3 4.8-2.6 9.6-1.5 5.6-11.6 43.6c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 12.1-41.2 7.2-24.4 9.8 23.5 .4 1c3.3 7.9 8.7 14.8 15.5 19.9l28.5 21.4c14.1 10.6 34.2 7.7 44.8-6.4s7.7-34.2-6.4-44.8l-25-18.8-16.5-39.7C568.5 154.8 528.3 128 483.7 128c-22.8 0-45.3 4.8-66.1 14l-5.7 2.5c-34.6 15.4-60.7 45.3-71.1 81.8l-3.7 12.9c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l3.7-12.9c4.1-14.3 13-26.6 24.9-34.9zM580 52A52 52 0 1 0 476 52a52 52 0 1 0 104 0zM419 343.9c-4.1-1.6-8.8 .4-10.4 4.5L388.7 398l-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l61.7-61.7c4.6-4.6 8.2-10.1 10.6-16.1L462.1 387c1.6-4.1-.4-8.8-4.5-10.4s-8.8 .4-10.4 4.5l-15.1 37.9c-1.6 4-4 7.7-7.1 10.7l-61.7 61.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l60.5-60.5 1.2-1.2 .6-1.5 20.5-51.1c1.6-4.1-.4-8.8-4.5-10.4z"]
}, Pa = Sa, Oa = {
  prefix: "fat",
  iconName: "phone",
  icon: [512, 512, [128222, 128379], "f095", "M317.1 378.1c-4.7 5.7-12.6 7.5-19.2 4.3c-73.8-34.8-133.5-94.5-168.3-168.3c-3.1-6.6-1.3-14.6 4.3-19.2l49.3-40.4c8.2-6.7 11-18 7-27.8l-40-96c-4.6-11.1-16.8-17.1-28.5-13.9l-88 24C23.2 43.7 16 53.2 16 64c0 238.6 193.4 432 432 432c10.8 0 20.3-7.2 23.2-17.7l24-88c3.2-11.6-2.8-23.8-13.9-28.5l-96-40c-9.8-4.1-21.1-1.3-27.8 7l-40.4 49.3zM304.7 368L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7z"]
}, Ea = {
  prefix: "fat",
  iconName: "rocket-launch",
  icon: [512, 512, [128640], "e027", "M209.7 302.3c-15.3-15.3-34.9-25.3-55.9-28.9c31-125.8 90-191.8 150.9-225.1C367.6 14 435 13.2 481.2 21.1c5 .9 8.8 4.7 9.7 9.7c8 46.1 7.2 113.5-27.2 176.5c-33.3 60.9-99.3 119.9-225.1 150.9c-3.6-21-13.6-40.6-28.9-55.9zM240 375.6l0-1.2c51.4-12.5 93.6-29.6 128-49.8l0 85.7c0 15.2-8.6 29-22.1 35.8l-94.3 47.2c-5.3 2.7-11.6-1.2-11.6-7.2l0-110.5zm144 34.7l0-95.7C510.9 230.8 519.5 102.5 506.6 28.1c-2-11.6-11.1-20.7-22.7-22.7C409.5-7.5 281.3 1.1 197.4 128H101.7c-21.2 0-40.6 12-50.1 31L4.4 253.3c-8 16 3.6 34.7 21.5 34.7l110.5 0c23.2 0 45.5 9.2 61.9 25.7s25.7 38.7 25.7 61.9l0 110.5c0 17.8 18.8 29.4 34.7 21.5L353 460.4c19-9.5 31-28.9 31-50.1zM137.7 272l-1.2 0H25.9c-5.9 0-9.8-6.3-7.2-11.6l47.2-94.3c6.8-13.6 20.6-22.1 35.8-22.1h85.7c-20.2 34.4-37.3 76.6-49.8 128zm17.5 186.7c-14.1 14.1-35.8 23.4-60.2 29.2c-24.1 5.7-48.8 7.6-67 8c-6.8 .2-12-5-11.8-11.8c.4-18.2 2.3-43 8-67c5.8-24.4 15.1-46.1 29.2-60.2c28.1-28.1 73.8-28.1 101.9 0s28.1 73.8 0 101.9zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C7.7 379.7 1 446 .1 483.7c-.4 16 12.2 28.6 28.2 28.2C66 511 132.3 504.3 166.5 470zM408 144a40 40 0 1 1 -80 0 40 40 0 1 1 80 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"]
}, $a = {
  prefix: "fat",
  iconName: "garage-car",
  icon: [640, 512, [], "e00a", "M329.1 20.4c-5.8-2.4-12.4-2.4-18.2 0L40.8 131.2c-15 6.2-24.8 20.8-24.8 37V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V168.2c0-22.7 13.7-43.2 34.7-51.8L304.8 5.6c9.7-4 20.6-4 30.4 0L605.3 116.4c21 8.6 34.7 29.1 34.7 51.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V168.2c0-16.2-9.8-30.8-24.8-37L329.1 20.4zM120 208c-4.4 0-8 3.6-8 8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V216c0-13.3 10.7-24 24-24H520c13.3 0 24 10.7 24 24V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V216c0-4.4-3.6-8-8-8H120zm111.5 64.6L211 336H429l-20.5-63.4c-3.2-9.9-12.4-16.6-22.8-16.6H254.4c-10.4 0-19.6 6.7-22.8 16.6zm-38.1 65.6l22.9-70.6c5.3-16.5 20.7-27.7 38.1-27.7H385.6c17.3 0 32.7 11.2 38.1 27.7l22.9 70.6c19.4 6.2 33.5 24.3 33.5 45.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V464H176v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V384c0-21.4 14.1-39.6 33.5-45.8zM432 352H208c-17.7 0-32 14.3-32 32v64H464V384c0-17.7-14.3-32-32-32zM224 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm176 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
}, Ia = {
  prefix: "fat",
  iconName: "person-digging",
  icon: [576, 512, ["digging"], "f85e", "M256 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm92.8 409.6c-3 4-7.8 6.4-12.8 6.4H304c-6.1 0-11.6 3.4-14.3 8.8l-16 32c-2.5 5-2.2 10.9 .7 15.6s8.1 7.6 13.6 7.6H544c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-96-160c-2.7-4.6-7.6-7.5-12.9-7.7s-10.4 2.1-13.6 6.4L348.8 425.6zM449.6 288c10.6 .5 20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l26.2-35L20.1 191c-3.9-2.1-5.3-7-3.1-10.9s7-5.3 10.9-3.1l39.4 21.9 16.3-27.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l39 117 3.6 10.9 55 30.5 50.5-67.3c6.4-8.5 16.6-13.3 27.2-12.8zm-153.4 38L259.1 214.7C245 172.5 205.5 144 161 144c-26.1 0-50.3 13.7-63.7 36.1l-16 26.6L296.2 326.1zM55.9 288.9l10.6-35.5 14.3 8-9.6 32.1L40.7 395.4l-24 80c-2.5 8.5 2.3 17.4 10.7 19.9s17.4-2.3 19.9-10.7l24-80 19-63.3c1.4-4.7 4.9-8.4 9.4-10.3s9.6-1.5 13.9 1L167.9 363c5 2.8 8.1 8.2 8.1 13.9V480c0 8.8 7.2 16 16 16s16-7.2 16-16V358.3 332l16 8.9v17.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V376.9L119.9 354l-14.3-8.1-4.7 15.7L86.7 409.2l-24 80c-5.1 16.9-22.9 26.5-39.8 21.5S-3.7 487.7 1.4 470.8l24-80L55.9 288.9z"]
}, Ta = {
  prefix: "fat",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M177.7 16h92.5c8.3 0 16 4.3 20.4 11.3l23 36.7H134.4l23-36.7c4.4-7 12.1-11.3 20.4-11.3zm-33.9 2.8L115.6 64H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H332.4L304.2 18.8C296.9 7.1 284.1 0 270.3 0H177.7c-13.8 0-26.6 7.1-33.9 18.8zM48 119.3c-.4-4.4-4.2-7.7-8.6-7.3s-7.7 4.2-7.3 8.6l28.3 340c2.4 29 26.7 51.4 55.8 51.4H331.8c29.1 0 53.4-22.3 55.8-51.4l28.3-340c.4-4.4-2.9-8.3-7.3-8.6s-8.3 2.9-8.6 7.3l-28.3 340C370 480.1 352.6 496 331.8 496H116.2c-20.8 0-38.1-15.9-39.9-36.7L48 119.3z"]
}, _a = {
  prefix: "fat",
  iconName: "file-pdf",
  icon: [512, 512, [], "f1c1", "M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM176 368h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H184v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V456 376c0-4.4 3.6-8 8-8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H184v64h24zm96-80h32c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H304c-4.4 0-8-3.6-8-8V376c0-4.4 3.6-8 8-8zm8 128h24c13.3 0 24-10.7 24-24V408c0-13.3-10.7-24-24-24H312V496zM424 376c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v48h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V440 376z"]
}, Ra = {
  prefix: "fat",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V216c0-4.4-3.6-8-8-8H224c-4.4 0-8 3.6-8 8s3.6 8 8 8h24V352H208zm48-176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
}, Da = {
  prefix: "fat",
  iconName: "calendar-check",
  icon: [448, 512, [], "f274", "M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM333.7 285.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L208 388.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l72 72c3.1 3.1 8.2 3.1 11.3 0l120-120z"]
}, Fa = {
  prefix: "fat",
  iconName: "calendar-clock",
  icon: [576, 512, ["calendar-time"], "e0d2", "M120 0c4.4 0 8 3.6 8 8V64H320V8c0-4.4 3.6-8 8-8s8 3.6 8 8V64h48c35.3 0 64 28.7 64 64v48 16 .7c-5.3-.5-10.6-.7-16-.7H16V448c0 26.5 21.5 48 48 48H311.2c6.1 5.8 12.7 11.1 19.6 16H64c-35.3 0-64-28.7-64-64V192 176 128C0 92.7 28.7 64 64 64h48V8c0-4.4 3.6-8 8-8zm-8 120V80H64c-26.5 0-48 21.5-48 48v48H432V128c0-26.5-21.5-48-48-48H336v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V80H128v40c0 4.4-3.6 8-8 8s-8-3.6-8-8zM432 496a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-272a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c4.4 0 8 3.6 8 8v64h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H432c-4.4 0-8-3.6-8-8V296c0-4.4 3.6-8 8-8z"]
}, ja = {
  prefix: "fat",
  iconName: "arrow-down-arrow-up",
  icon: [576, 512, ["sort-alt"], "f883", "M421.7 34.3l112 112c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L424 59.3V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V59.3l-98.3 98.3c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l112-112c3.1-3.1 8.2-3.1 11.3 0zm-144 331.3l-112 112c-3.1 3.1-8.2 3.1-11.3 0l-112-112c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L152 452.7V40c0-4.4 3.6-8 8-8s8 3.6 8 8V452.7l98.3-98.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z"]
}, Ya = ja, Ua = {
  prefix: "fat",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM80 448V202.9L288 18.7 496 202.9V448c0 26.5-21.5 48-48 48H368V328c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24V496H128c-26.5 0-48-21.5-48-48zm144 48V328c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8V496H224z"]
}, Wa = {
  prefix: "fat",
  iconName: "calendar-week",
  icon: [448, 512, [], "f784", "M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM96 272H352c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM64 288v64c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"]
}, qa = {
  prefix: "fat",
  iconName: "car",
  icon: [512, 512, [128664, "automobile"], "f1b9", "M106.4 88.6L76.3 194c6.4-1.3 12.9-2 19.7-2H416c6.7 0 13.3 .7 19.7 2L405.6 88.6c-6.9-24-28.8-40.6-53.8-40.6H160.3c-25 0-47 16.6-53.8 40.6zM58 199.8L91 84.2C99.9 53.3 128.1 32 160.3 32H351.7c32.1 0 60.4 21.3 69.2 52.2l33 115.6c34.1 14.7 58 48.7 58 88.2v96 16 48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 384 288c0-39.5 23.9-73.5 58-88.2zM416 384h16 64V288c0-44.2-35.8-80-80-80H96c-44.2 0-80 35.8-80 80v96H80 96 416zm16 16v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400H432zM16 400v48c0 8.8 7.2 16 16 16H64c8.8 0 16-7.2 16-16V400H16zm96-112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-48 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm352 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
}, Ba = {
  prefix: "fat",
  iconName: "square-pen",
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M64 48C37.5 48 16 69.5 16 96V416c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V96c0-26.5-21.5-48-48-48H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM100.7 379.2c-4-4-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9L275.4 133.5c15.6-15.6 40.9-15.6 56.6 0l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2zM335 193.1c9.4-9.4 9.4-24.6 0-33.9l-14.4-14.4c-9.4-9.4-24.6-9.4-33.9 0l-25.3 25.3 48.3 48.3L335 193.1zM179.6 348.6L298.4 229.7l-48.3-48.3L131.2 300.3c-2.1 2.1-3.5 4.6-4.2 7.4l-10.6 42.5L112 367.9l17.6-4.4 42.5-10.6c2.8-.7 5.4-2.2 7.4-4.2z"]
}, Xa = Ba, Ga = {
  prefix: "fat",
  iconName: "money-bill-simple-wave",
  icon: [576, 512, [], "e1f2", "M16 422.3c0 12.4 6.9 22.7 16.6 26.3c78.1 29.1 156.8 11.7 240.7-9.6c4-1 8-2 12-3.1c78.7-20.1 162.3-41.4 246.3-18.5c15.2 4.2 28.4-6.9 28.4-17.9V89.7c0-12.4-6.9-22.7-16.6-26.3C465.3 34.2 386.7 51.7 302.8 73c-4 1-8 2-12 3.1l0 0C212 96.2 128.4 117.5 44.4 94.6C29.2 90.4 16 101.5 16 112.5V422.3zm-16 0V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM216 256c0 50 33.5 88 72 88s72-38 72-88s-33.5-88-72-88s-72 38-72 88zm72-104c49.9 0 88 48 88 104s-38.1 104-88 104s-88-48-88-104s38.1-104 88-104z"]
}, Ka = {
  prefix: "fat",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M250.3 397.7c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 380.7 45.7 170.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l216 216z"]
}, Qa = {
  prefix: "fat",
  iconName: "car-burst",
  icon: [640, 512, ["car-crash"], "f5e1", "M161.5 20.5c5.7-12.4 23.4-12.4 29.1 0l31.4 68.2 58.9-14.6L269.1 93.5l-49.8 12.3c-3.7 .9-7.6-.9-9.2-4.4L176 27.2l-34.1 74.2c-1.6 3.5-5.5 5.3-9.2 4.4L53.4 86.2l36.8 73c1.7 3.3 .9 7.3-1.9 9.7L29.7 218.9l73.5 16.8c3.7 .8 6.3 4.2 6.2 7.9l-1.5 81.7L142.1 297 135 323.7l-16.8 13.9c-10.5 8.7-26.4 1.1-26.2-12.6l1.4-75.2L26.1 234.5c-12.8-2.9-16.8-19.2-6.8-27.8l53.7-46L39.1 93.4c-6.2-12.2 4.9-26 18.1-22.7l72.9 18 31.4-68.2zm146.8 70c16.5-27.6 49.3-40.8 80.4-32.5l154 41.3c31.1 8.3 52.8 36.2 53.4 68.4l1.7 100.9c23 23.5 33.4 58.1 24.3 92.2l-18.6 69.5-4.1 15.5L591 476.5c-4.6 17.1-22.1 27.2-39.2 22.6l-30.9-8.3c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9L259.2 354.5 251 385.4c-4.6 17.1-22.1 27.2-39.2 22.6l-30.9-8.3c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9 4.1-15.5 18.6-69.5c9.1-34.1 35.5-58.9 67.1-67.7l51.9-86.5zm271.8 77.4c-.4-25-17.3-46.7-41.5-53.2l-154-41.3c-24.2-6.5-49.7 3.9-62.5 25.3l-44.9 75c9.8-.5 19.8 .5 29.8 3.2L554.1 243c10 2.7 19.2 6.8 27.4 12.1l-1.4-87.4zM587.9 426l18.6-69.5c11.4-42.7-13.9-86.5-56.6-98L302.7 192.2c-42.7-11.4-86.5 13.9-98 56.6l-18.6 69.5 61.8 16.6 15.5 4.1 247.3 66.3 15.5 4.1L587.9 426zm-66-1.1l-8.3 30.9c-2.3 8.5 2.8 17.3 11.3 19.6l30.9 8.3c8.5 2.3 17.3-2.8 19.6-11.3l8.3-30.9L522 424.9zM243.8 350.4L182 333.8l-8.3 30.9c-2.3 8.5 2.8 17.3 11.3 19.6l30.9 8.3c8.5 2.3 17.3-2.8 19.6-11.3l8.3-30.9zm48-86.5a16 16 0 1 0 -30.9-8.3 16 16 0 1 0 30.9 8.3zm-46.4-12.4A32 32 0 1 1 307.3 268a32 32 0 1 1 -61.8-16.6zm289.5 94.1a16 16 0 1 0 8.3-30.9 16 16 0 1 0 -8.3 30.9zm12.4-46.4A32 32 0 1 1 530.8 361a32 32 0 1 1 16.6-61.8z"]
}, Za = Qa, Ja = {
  prefix: "fat",
  iconName: "copy",
  icon: [512, 512, [], "f0c5", "M448 368H288c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H396.1c8.5 0 16.6 3.4 22.6 9.4l67.9 67.9c6 6 9.4 14.1 9.4 22.6V320c0 26.5-21.5 48-48 48zM288 384H448c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L430.1 14.1c-9-9-21.2-14.1-33.9-14.1H288c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V416H272v32c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48H192V128H64z"]
}, ae = {
  prefix: "fat",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M338.1 413.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L203.3 256 349.4 109.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 244.7 45.9 98.6c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 34.6 402.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 267.3 338.1 413.4z"]
}, ee = {
  prefix: "fat",
  iconName: "rocket",
  icon: [512, 512, [], "f135", "M127.1 332.8l50.7 50.7c4.6 4.6 11.3 5.9 17 3.4c42.4-17.8 140.5-60.7 191.5-95.4C499.6 214.7 503.8 100.7 491 31c-.9-5.1-4.8-9-9.9-9.9C411.3 8.2 297.3 12.4 220.5 125.7c-34.5 50.9-78.3 147.8-96.7 189.9c-2.5 5.8-1.3 12.5 3.4 17.2zm39.3 62l-50.7-50.7c-9.2-9.2-11.9-23-6.7-34.9c2.6-6 5.8-13.2 9.4-21.2H25.9C8 288-3.6 269.2 4.4 253.3L51.6 159c9.5-19 28.9-31 50.1-31l98.2 0c2.5-4 4.9-7.7 7.3-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.6 2.4-7.3 4.9-11.3 7.3l0 98.2c0 21.2-12 40.6-31 50.1l-94.3 47.2c-16 8-34.7-3.6-34.7-21.5l0-94.3c-8.8 3.8-16.6 7.1-23 9.8c-11.8 5-25.4 2.2-34.5-6.9zM25.9 272l99.8 0c17.5-38.3 41.6-88.8 64.5-128H101.7c-15.2 0-29 8.6-35.8 22.1L18.7 260.4c-2.7 5.3 1.2 11.6 7.2 11.6zM240 384.8V486.1c0 5.9 6.3 9.8 11.6 7.2l94.3-47.2c13.6-6.8 22.1-20.6 22.1-35.8V321.7c-39.1 22.6-89.5 46.1-128 63.1zM328 144a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112z"]
}, ne = {
  prefix: "fat",
  iconName: "spinner",
  icon: [512, 512, [], "f110", "M256 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM131.5 380.5A32 32 0 1 0 86.3 425.7a32 32 0 1 0 45.3-45.3zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM86.3 131.5a32 32 0 1 0 45.3-45.3A32 32 0 1 0 86.3 131.5zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM425.7 425.7a32 32 0 1 0 -45.3-45.3 32 32 0 1 0 45.3 45.3zm-56.6-56.6A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"]
}, te = {
  prefix: "fat",
  iconName: "clock-rotate-left",
  icon: [512, 512, ["history"], "f1da", "M16 166.7V56c0-4.4-3.6-8-8-8s-8 3.6-8 8V184c0 4.4 3.6 8 8 8H136c4.4 0 8-3.6 8-8s-3.6-8-8-8H29.7C62.6 82.8 151.5 16 256 16c132.5 0 240 107.5 240 240s-107.5 240-240 240c-73.5 0-139.3-33.1-183.4-85.2c-2.9-3.4-7.9-3.8-11.3-.9s-3.8 7.9-.9 11.3C107.3 476.7 177.6 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C146 0 52.2 69.4 16 166.7zM256 128c-4.4 0-8 3.6-8 8V256c0 2.1 .8 4.2 2.3 5.7l88 88c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L264 252.7V136c0-4.4-3.6-8-8-8z"]
}, re = te, ce = {
  prefix: "fat",
  iconName: "file-export",
  icon: [576, 512, ["arrow-right-from-file"], "f56e", "M368 448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V256h16V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V352H368v96zm-6.9-288H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3c.9 .9 1.7 1.8 2.4 2.7zm100.6 26.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L548.7 296H200c-4.4 0-8 3.6-8 8s3.6 8 8 8H548.7l-98.3 98.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l112-112c3.1-3.1 3.1-8.2 0-11.3l-112-112z"]
}, ie = {
  prefix: "fat",
  iconName: "circle-plus",
  icon: [512, 512, ["plus-circle"], "f055", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-8-160c0 4.4 3.6 8 8 8s8-3.6 8-8V264h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V160c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z"]
}, oe = {
  prefix: "fat",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M437.7 106.3c3.1 3.1 3.1 8.2 0 11.3l-272 272c-3.1 3.1-8.2 3.1-11.3 0l-144-144c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L160 372.7 426.3 106.3c3.1-3.1 8.2-3.1 11.3 0z"]
}, se = {
  prefix: "fat",
  iconName: "calendar-day",
  icon: [448, 512, [], "f783", "M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM16 192H432V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V192zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM80 288c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V288zm-16 0v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"]
}, le = {
  prefix: "fat",
  iconName: "bandage",
  icon: [640, 512, [129657, "band-aid"], "f462", "M480 112V400h80c35.3 0 64-28.7 64-64V176c0-35.3-28.7-64-64-64H480zm-16 0H176V400H464V112zM160 400V112H80c-35.3 0-64 28.7-64 64V336c0 35.3 28.7 64 64 64h80zm0-304h16H464h16 80c44.2 0 80 35.8 80 80V336c0 44.2-35.8 80-80 80H480 464 176 160 80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h80zm112 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-80 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
}, fe = le, ue = {
  prefix: "fat",
  iconName: "user-injured",
  icon: [448, 512, [], "f728", "M336 128c0-8.2-.9-16.3-2.6-24H192 114.6c-1.7 7.7-2.6 15.8-2.6 24c0 61.9 50.1 112 112 112s112-50.1 112-112zm-7.4-40c-10.3-26.8-30.6-48.7-56.3-61l-61 61H328.6zM256 20.6c-10.2-3-20.9-4.6-32-4.6c-47.8 0-88.5 29.9-104.6 72h69.3L256 20.6zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM16 482.3c0 7.6 6.1 13.7 13.7 13.7H80V353.1c-38.9 29.6-64 76.5-64 129.1zM96 344V496h72 16 43.7 21.5L137.8 325.1c-14.9 3.8-29 9.7-41.9 17.4c.1 .5 .1 1 .1 1.5zM296 496c22.1 0 40-17.9 40-40s-17.9-40-40-40H216.2l52.2 80H296zm0-96c30.9 0 56 25.1 56 56c0 15.7-6.4 29.8-16.8 40h83.1c7.6 0 13.7-6.1 13.7-13.7C432 392.7 359.3 320 269.7 320H178.3c-8 0-15.9 .6-23.6 1.7L205.7 400H296zM418.3 512H296 176h-8H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7z"]
}, me = {
  prefix: "fad",
  iconName: "circle-minus",
  icon: [512, 512, ["minus-circle"], "f056", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M160 256c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24z"]]
}, ve = {
  prefix: "fad",
  iconName: "message-bot",
  icon: [640, 512, [], "e3b8", ["M96 64c0-35.3 28.7-64 64-64H480c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H373.3L249.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H160c-35.3 0-64-28.7-64-64V64zm96 32c-17.7 0-32 14.3-32 32V256c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192z", "M59.7 208c-5.5 9.6-15.9 16-27.7 16c-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16H96v32H59.7zM192 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 32c0 17.7-14.3 32-32 32c-11.8 0-22.2-6.4-27.7-16H544V176h36.3c5.5-9.6 15.9-16 27.7-16c17.7 0 32 14.3 32 32z"]]
}, de = {
  prefix: "fad",
  iconName: "message-exclamation",
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM256 80c-13.3 0-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M280 104c0-13.3-10.7-24-24-24s-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104zM256 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
}, pe = {
  prefix: "fad",
  iconName: "chevrons-left",
  icon: [512, 512, ["chevron-double-left"], "f323", ["M233.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l192-192c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L301.3 256 470.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-192-192z", "M41.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l192-192c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256 278.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-192-192z"]]
}, he = {
  prefix: "fad",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", ["M492.7 58.2c25 25 25 65.5 0 90.5l-60 60L302.7 78.7l60-60c25-25 65.5-25 90.5 0l39.4 39.4zM315.3 186.7l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z", "M432.7 208.7L302.7 78.7 58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L432.7 208.7zM89.3 360.5l22.7-9.1v32c0 8.8 7.2 16 16 16h32l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3zm226-196.4c6.2 6.2 6.2 16.4 0 22.6l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0z"]]
}, ge = he, be = {
  prefix: "fad",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
}, ze = {
  prefix: "fad",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", ["M0 160c0-53 43-96 96-96h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 53-43 96-96 96H96c-53 0-96-43-96-96V160z", "M392.4 21.7L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0zM339.7 74.3L172.4 241.7c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3z"]]
}, ye = {
  prefix: "fad",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", ["M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z", ""]]
}, He = {
  prefix: "fad",
  iconName: "user-helmet-safety",
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", ["M97 176c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128s128-57.3 128-128c0-5.4-.3-10.8-1-16H97z", "M216 0c-13.3 0-24 10.7-24 24V80L163.6 23.1C125.6 43.5 99 82.6 96.2 128H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24h-.2C349 82.6 322.4 43.5 284.4 23.1L256 80V24c0-13.3-10.7-24-24-24H216zM134.4 352C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352H134.4z"]]
}, Me = {
  prefix: "fad",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", ["M327.5 85.2L384 64 405.2 7.5C406.9 3 411.2 0 416 0s9.1 3 10.8 7.5L448 64l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8s-3 9.1-7.5 10.8L448 128l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5s-9.1-3-10.8-7.5L384 128l-56.5-21.2c-4.5-1.7-7.5-6-7.5-10.8s3-9.1 7.5-10.8zm0 320L384 384l21.2-56.5c1.7-4.5 6-7.5 10.8-7.5s9.1 3 10.8 7.5L448 384l56.5 21.2c4.5 1.7 7.5 6 7.5 10.8s-3 9.1-7.5 10.8L448 448l-21.2 56.5c-1.7 4.5-6 7.5-10.8 7.5s-9.1-3-10.8-7.5L384 448l-56.5-21.2c-4.5-1.7-7.5-6-7.5-10.8s3-9.1 7.5-10.8z", "M205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.4 187.4 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3z"]]
}, xe = {
  prefix: "fad",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]]
}, Le = {
  prefix: "fad",
  iconName: "cloud-arrow-up",
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", ["M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z", "M223 297c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39L344 392c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-134.1-39 39c-9.4 9.4-24.6 9.4-33.9 0z"]]
}, Ve = {
  prefix: "fad",
  iconName: "triangle-person-digging",
  icon: [640, 512, ["construction"], "f85d", ["M354.5 51.8C347.3 39.5 334.2 32 320 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S89.7 480 104 480H536c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368zM216.9 304.7l15.6 9.8 64 40c4.7 2.9 7.5 8.1 7.5 13.6v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V376.9l-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8zm112-45.7l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1H384c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9zM288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm40.8 74.9l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1H384c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9zm-96.3 55.5l64 40c4.7 2.9 7.5 8.1 7.5 13.6v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V376.9l-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8 15.6 9.8z"]]
}, Ce = Ve, ke = {
  prefix: "fad",
  iconName: "cloud-bolt",
  icon: [512, 512, [127785, "thunderstorm"], "f76c", ["M334.3 247.2c3.4-6.7 1.6-14.9-4.2-19.6s-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8z", "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H352 333.7l29.3-58.5c10.1-20.2 4.8-44.6-12.8-58.8s-42.6-14.2-60.2-.2L143.2 320H96z"]]
}, we = {
  prefix: "fad",
  iconName: "file-contract",
  icon: [384, 512, [], "f56c", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm54.2 253.8L144 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l8.8-17.7c1.7-3.4 5.1-5.5 8.8-5.5s7.2 2.1 8.8 5.5l8.8 17.7c2.7 5.4 8.3 8.8 14.3 8.8h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H249.9l-4.4-8.8C238.4 361 223.9 352 208 352c-10 0-19.4 3.5-26.8 9.7l-11.6-38.6C166.2 311.7 155.8 304 144 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.2c21.2 0 39.9-13.9 46-34.2z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM134.2 381.8L144 349l16.7 55.6c1.9 6.3 7.4 10.8 13.9 11.3s12.8-2.9 15.7-8.8l8.8-17.7c1.7-3.4 5.1-5.5 8.8-5.5s7.2 2.1 8.8 5.5l8.8 17.7c2.7 5.4 8.3 8.8 14.3 8.8h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H249.9l-4.4-8.8C238.4 361 223.9 352 208 352c-10 0-19.4 3.5-26.8 9.7l-11.6-38.6C166.2 311.7 155.8 304 144 304s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.2c21.2 0 39.9-13.9 46-34.2z"]]
}, Ne = {
  prefix: "fad",
  iconName: "telescope",
  icon: [576, 512, [128301], "e03e", ["M361 76.6c.7 2.4 1.7 4.8 3 7.1L460 250c.2 .4 .5 .8 .7 1.2l-77.5 41.6C377.8 253.9 344.4 224 304 224c-44.2 0-80 35.8-80 80c0 20.1 7.4 38.5 19.7 52.5l-5.8 14.2-88.4 47.4c-15.2 8.2-34.2 2.8-42.8-12.2l-.8-1.4L61.7 430.1c-11.5 6.6-26.2 2.7-32.8-8.8L3.1 376.4c-6.6-11.5-2.7-26.2 8.8-32.8l44.1-25.5-4-6.9c-8.5-14.8-4-33.7 10.4-42.9L361 76.6z", "M375.7 40c-15.3 8.8-20.6 28.4-11.7 43.7L460 250c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8L375.7 40zM364.3 356.5C376.6 342.5 384 324.1 384 304c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 20.1 7.4 38.5 19.7 52.5L193.8 478.9c-5 12.3 .9 26.3 13.2 31.3s26.3-.9 31.3-13.2l47-115.3c6 1.5 12.3 2.2 18.8 2.2s12.8-.8 18.8-2.2l47 115.3c5 12.3 19 18.2 31.3 13.2s18.2-19 13.2-31.3L364.3 356.5zM272 304a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]]
}, Ae = {
  prefix: "fad",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M222.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
}, Se = {
  prefix: "fad",
  iconName: "pen",
  icon: [512, 512, [128394], "f304", ["M362.7 19.3c25-25 65.5-25 90.5 0l39.4 39.4c25 25 25 65.5 0 90.5L433 209 303 79l59.7-59.7z", "M433 209L303 79 52.8 329.3c-6.6 6.6-11.5 14.8-14.1 23.8L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l128.2-37.7c9-2.6 17.2-7.5 23.8-14.1L433 209z"]]
}, Pe = {
  prefix: "fad",
  iconName: "scale-unbalanced",
  icon: [640, 512, ["balance-scale-left"], "f515", ["M521 62.4c16.8-5.6 25.8-23.7 20.2-40.5S517.5-3.9 500.7 1.6l-113 37.7C373.8 15.8 348.2 0 318.8 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L116.7 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32s-14.3-32-32-32h-160V153.3c21-9.2 37.2-27 44.2-49L521 62.4z", "M510.8 163.8L583.3 288H438.4l72.4-124.2zm-126 141.3C395.7 350 448 384 510.8 384s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L534.9 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L391.6 273.1c-5.7 9.8-9.3 21.1-6.7 32.1zM128 291.8L200.4 416H55.6L128 291.8zM2 433.1C12.8 478 65.1 512 128 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L152.1 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L8.7 401.1C3 410.8-.6 422.1 2 433.1z"]]
}, Oe = {
  prefix: "fad",
  iconName: "hand-holding-dollar",
  icon: [576, 512, ["hand-holding-usd"], "f4c0", ["M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .2 .5 .5 0 1 1 .9-.2z", "M288 0c13.3 0 24 10.7 24 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24z"]]
}, Ee = {
  prefix: "fad",
  iconName: "house-person-leave",
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", ["M261.7 16.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.7 8.9-12.9 22.9-8.1 35.2S18.8 264 32 264H64V376c0 26.5 21.5 48 48 48H317.5l44-44 32.6-81.6c-14.1 6.3-30.5 7.5-46.3 2.3c-33.5-11.2-51.7-47.4-40.5-81l2.6-7.8c12.2-36.5 37-67.2 69.6-86.7L261.7 16.5zM160 192h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H160c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16z", "M480 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM446.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L601 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L567 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM388.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L388.7 398z"]]
}, $e = Ee, Ie = {
  prefix: "fad",
  iconName: "phone",
  icon: [512, 512, [128222, 128379], "f095", ["M505.7 412.3l-8.5 31.2c-71.8-8.7-138.9-32.9-197.8-69.1l20.5-25c55.4 33.4 118.4 55.4 185.8 62.9zM99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8l-25 20.5C101.4 153.7 77.2 86.6 68.4 14.8L99.7 6.3z", "M68.4 14.8l-39 10.6C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l10.6-39C273.2 416.4 95.6 238.8 68.4 14.8zM505.7 412.3l4.9-17.8c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6l-25.1 30.7c55.4 33.4 118.4 55.4 185.8 62.9zM162.6 192.1L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2L99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8z"]]
}, Te = {
  prefix: "fad",
  iconName: "rocket-launch",
  icon: [512, 512, [128640], "e027", ["M118.5 288H24c-8.7 0-16.7-4.7-20.9-12.2s-4.1-16.8 .4-24.2l52.8-86.9C69.3 143.2 92.6 130 117.8 130h80.8c-28.5 45.8-60.7 114.5-80.1 158zM382 313.4v80.8c0 25.2-13.1 48.5-34.6 61.5l-86.9 52.8c-7.4 4.5-16.7 4.7-24.2 .4s-12.2-12.2-12.2-20.9l0-96.2c43.9-19.1 112.4-50.3 158-78.4zM166.5 470C132.3 504.3 66 511 28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5zm-46.7-36.4c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3c-.5 8 5.9 14.3 13.9 13.9c12.8-.7 31.2-3.7 41.3-13.7z", "M223.7 391.9c-4-56-49.1-100.6-105.3-103.8c21.4-47.9 58.4-126.6 88.8-171.5C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-44.7 30.3-123.1 66.2-171.6 87.2zM424 128a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"]]
}, _e = {
  prefix: "fad",
  iconName: "garage-car",
  icon: [640, 512, [], "e00a", ["M261.8 288H378.2c3.4 0 6.4 2.2 7.6 5.4L397.8 328H242.2l12.1-34.6c1.1-3.2 4.2-5.4 7.6-5.4zM209 277.5L188.9 335c-17.2 9.5-28.9 27.9-28.9 49v96c0 17.7 14.3 32 32 32s32-14.3 32-32V464H416v16c0 17.7 14.3 32 32 32s32-14.3 32-32V384c0-21.1-11.7-39.5-28.9-49L431 277.5C423.2 255.1 402 240 378.2 240H261.8c-23.8 0-45 15.1-52.9 37.5zM216 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M0 171.3V488c0 13.3 10.7 24 24 24H72c13.3 0 24-10.7 24-24V224c0-17.7 14.3-32 32-32H512c17.7 0 32 14.3 32 32V488c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V171.3c0-26.2-15.9-49.7-40.2-59.4L331.9 4.8c-7.6-3.1-16.1-3.1-23.8 0L40.2 111.9C15.9 121.6 0 145.2 0 171.3z"]]
}, Re = {
  prefix: "fad",
  iconName: "person-digging",
  icon: [576, 512, ["digging"], "f85e", ["M9.8 214.8c5.1-12.2 19.1-18 31.4-12.9l347 144.6 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4z", "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM60.6 292.9l32 13.7 112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33zm.1-82.9l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7L60.7 210z"]]
}, De = {
  prefix: "fad",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", ["M394.6 466.8L416 96H32L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2H346.7c25.4 0 46.5-19.8 47.9-45.2z", "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8z"]]
}, Fe = {
  prefix: "fad",
  iconName: "file-pdf",
  icon: [512, 512, [], "f1c1", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM176 352c-8.8 0-16 7.2-16 16v80 48c0 8.8 7.2 16 16 16s16-7.2 16-16V464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56H176zm32 80H192V384h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H304zm32 128H320V384h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16zm80-112v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V384h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16z"]]
}, je = {
  prefix: "fad",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V272H216c-13.3 0-24-10.7-24-24z"]]
}, Ye = {
  prefix: "fad",
  iconName: "calendar-check",
  icon: [448, 512, [], "f274", ["M448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM329 305L217 417c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"]]
}, Ue = {
  prefix: "fad",
  iconName: "calendar-clock",
  icon: [576, 512, ["calendar-time"], "e0d2", ["M432 192H0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176zm0 0c5.4 0 10.7 .2 16 .7V192H432z", "M128 0C110.3 0 96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]]
}, We = {
  prefix: "fad",
  iconName: "arrow-down-arrow-up",
  icon: [576, 512, ["sort-alt"], "f883", ["M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L448 141.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V141.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96z", "M137.4 470.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 370.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96z"]]
}, qe = We, Be = {
  prefix: "fad",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", ["M64 270.5L64.1 472c0 22.1 17.9 40 40 40H184c22.1 0 40-17.9 40-40V383.7c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V472c0 22.1 17.9 40 40 40h80.5c22.1 0 40-18 40-40.1l-.4-201.3L288 74.5 64 270.5z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z"]]
}, Xe = {
  prefix: "fad",
  iconName: "calendar-week",
  icon: [448, 512, [], "f784", ["M448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM80 256H368c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16z", "M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v80H0V112C0 85.5 21.5 64 48 64H96V32z"]]
}, Ge = {
  prefix: "fad",
  iconName: "car",
  icon: [512, 512, [128664, "automobile"], "f1b9", ["M165.4 96c-13.6 0-25.7 8.6-30.2 21.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4zM0 400v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V400H0zm512 0H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V400z", "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400H0V256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
}, Ke = {
  prefix: "fad",
  iconName: "square-pen",
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z", "M269.2 139.7l-21.4 21.4 71 71 21.4-21.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4c-15.6-15.6-40.9-15.6-56.6 0zm-44 44L119.9 289c-4.1 4.1-7 9.2-8.4 14.9L96.5 364c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L296.1 254.7l-71-71z"]]
}, Qe = Ke, Ze = {
  prefix: "fad",
  iconName: "money-bill-simple-wave",
  icon: [576, 512, [], "e1f2", ["M288 352c44.2 0 80-43 80-96s-35.8-96-80-96s-80 43-80 96s35.8 96 80 96z", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]]
}, Je = {
  prefix: "fad",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", ["M278.6 406.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 338.7 425.4 169.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z", ""]]
}, a6 = {
  prefix: "fad",
  iconName: "car-burst",
  icon: [640, 512, ["car-crash"], "f5e1", ["M160.6 18.8c2.7-6.7 12.2-6.7 14.9 0l26.3 66.6c1.5 3.9 5.8 5.9 9.8 4.7l68.5-21c6.9-2.1 12.9 5.3 9.3 11.6L266.7 120l-36.3 52.5c-27.4 8.9-49.9 31-57.9 60.9L166.8 255c-1.5 .2-3 .9-4.2 2L110 305.6c-5.3 4.9-13.9 .8-13.4-6.5l5.2-71.4c.3-4.2-2.6-7.9-6.8-8.5L24.2 208.4c-7.2-1.1-9.3-10.4-3.3-14.5L80 153.5c3.4-2.4 4.5-7 2.4-10.6L46.8 80.8c-3.6-6.3 2.3-13.8 9.3-11.6l68.5 21c4 1.2 8.3-.8 9.8-4.7l26.3-66.6zm42.9 222.9c1.5-5.6 3.8-10.8 6.7-15.4c-2.9 4.7-5.2 9.8-6.7 15.4l0 0z", "M350.4 167.8l-32.2 46.6 201.5 54L515 212c-.5-6.7-5.3-12.4-11.8-14.2L367.7 161.5c-6.5-1.8-13.5 .8-17.3 6.4zM249.8 200.7l47.9-69.3c19.2-27.8 53.9-40.5 86.5-31.8L519.8 136c32.7 8.8 56.3 37.1 59 70.8l6.8 84c17.2 13.4 25.6 36.3 19.6 58.7L595 388l-16.6 61.8-8.3 30.9c-4.6 17.1-22.1 27.2-39.2 22.6l-15.5-4.1c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9L253.8 362.9l-8.3 30.9c-4.6 17.1-22.1 27.2-39.2 22.6l-15.5-4.1c-17.1-4.6-27.2-22.1-22.6-39.2l8.3-30.9 16.6-61.8 10.4-38.6c6-22.4 24.7-38 46.3-41zm47.9 91.1a24 24 0 1 0 -46.4-12.4 24 24 0 1 0 46.4 12.4zm217.9 83.2A24 24 0 1 0 528 328.7a24 24 0 1 0 -12.4 46.4z"]]
}, e6 = a6, n6 = {
  prefix: "fad",
  iconName: "copy",
  icon: [512, 512, [], "f0c5", ["M192 128H48c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V416H256v32H64V192H192V128z", "M224 48c0-26.5 21.5-48 48-48H396.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V48z"]]
}, t6 = {
  prefix: "fad",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", ["M297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6z", ""]]
}, r6 = {
  prefix: "fad",
  iconName: "rocket",
  icon: [512, 512, [], "f135", ["M198.6 130c-28.5 45.8-60.7 114.5-80.1 158H24c-8.7 0-16.7-4.7-20.9-12.2s-4.1-16.8 .4-24.2l52.8-86.9C69.3 143.2 92.6 130 117.8 130h80.8zM224 391.8c43.9-19.1 112.4-50.3 158-78.4v80.8c0 25.2-13.1 48.5-34.6 61.5l-86.9 52.8c-7.4 4.5-16.7 4.7-24.2 .4s-12.2-12.2-12.2-20.9l0-96.2z", "M166.5 394.8l-50.7-50.7c-9.2-9.2-11.9-23-6.7-34.9c18.3-41.9 62.7-140.2 98.1-192.5C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7C342.6 340.5 243 383.9 201 401.7c-11.8 5-25.4 2.2-34.5-6.9zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]]
}, c6 = {
  prefix: "fad",
  iconName: "spinner",
  icon: [512, 512, [], "f110", ["M369.1 75A48 48 0 1 1 437 142.9 48 48 0 1 1 369.1 75zM416 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM208 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM75 369.1A48 48 0 1 1 142.9 437 48 48 0 1 1 75 369.1zm294.2 0A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 256A48 48 0 1 0 0 256a48 48 0 1 0 96 0zM75 142.9A48 48 0 1 0 142.9 75 48 48 0 1 0 75 142.9z"]]
}, i6 = {
  prefix: "fad",
  iconName: "clock-rotate-left",
  icon: [512, 512, ["history"], "f1da", ["M120.2 120.2C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8z", "M256 128c13.3 0 24 10.7 24 24v94.1l65 65c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72c-4.5-4.5-7-10.6-7-17V152c0-13.3 10.7-24 24-24z"]]
}, o6 = i6, s6 = {
  prefix: "fad",
  iconName: "file-export",
  icon: [576, 512, ["arrow-right-from-file"], "f56e", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zm105 55c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H494.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80z"]]
}, l6 = {
  prefix: "fad",
  iconName: "circle-plus",
  icon: [512, 512, ["plus-circle"], "f055", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M232 280v64c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
}, f6 = {
  prefix: "fad",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", ["", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]]
}, u6 = {
  prefix: "fad",
  iconName: "calendar-day",
  icon: [448, 512, [], "f783", ["M448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192zM80 256h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16z", "M96 32c0-17.7 14.3-32 32-32s32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v80H0V112C0 85.5 21.5 64 48 64H96V32z"]]
}, m6 = {
  prefix: "fad",
  iconName: "bandage",
  icon: [640, 512, [129657, "band-aid"], "f462", ["M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z", "M192 96H160V416h32V96zm288 0H448V416h32V96z"]]
}, v6 = m6, d6 = {
  prefix: "fad",
  iconName: "user-injured",
  icon: [448, 512, [], "f728", ["M96 128c0-11 1.4-21.8 4-32H348c2.6 10.2 4 21 4 32c0 70.7-57.3 128-128 128s-128-57.3-128-128zM272 512h-9.6l-57.6-96H272c26.5 0 48 21.5 48 48s-21.5 48-48 48zm0-128H185.6l-45.5-75.9c12.3-2.7 25.1-4.1 38.2-4.1h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H336c10-13.4 16-30 16-48c0-44.2-35.8-80-80-80zM0 482.3c0-55 24.9-104.1 64-136.8V512H29.7C13.3 512 0 498.7 0 482.3z", "M348 96c-6.7-25.9-21.3-48.7-41.1-65.5L222.6 96H348zM224 0C164.4 0 114.2 40.8 100 96h70.5L278.4 12.1C261.9 4.3 243.4 0 224 0zm38.4 512L140.1 308.1c-28.5 6.2-54.5 19.3-76.1 37.3V512H262.4z"]]
}, p6 = {
  prefix: "fas",
  iconName: "circle-minus",
  icon: [512, 512, ["minus-circle"], "f056", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
}, h6 = {
  prefix: "fas",
  iconName: "message-bot",
  icon: [640, 512, [], "e3b8", "M160 0C124.7 0 96 28.7 96 64V176H59.7c-5.5-9.6-15.9-16-27.7-16c-17.7 0-32 14.3-32 32s14.3 32 32 32c11.8 0 22.2-6.4 27.7-16H96V352c0 35.3 28.7 64 64 64h64v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416H480c35.3 0 64-28.7 64-64V208h36.3c5.5 9.6 15.9 16 27.7 16c17.7 0 32-14.3 32-32s-14.3-32-32-32c-11.8 0-22.2 6.4-27.7 16H544V64c0-35.3-28.7-64-64-64H160zm0 128c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V128zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, g6 = {
  prefix: "fas",
  iconName: "message-exclamation",
  icon: [512, 512, ["comment-alt-exclamation"], "f4a5", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM256 80c-13.3 0-24 10.7-24 24V216c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, b6 = {
  prefix: "fas",
  iconName: "chevrons-left",
  icon: [512, 512, ["chevron-double-left"], "f323", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zm384-192l-192 192c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 470.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"]
}, z6 = {
  prefix: "fas",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
}, y6 = z6, H6 = {
  prefix: "fas",
  iconName: "circle-exclamation",
  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, M6 = {
  prefix: "fas",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"]
}, x6 = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, L6 = {
  prefix: "fas",
  iconName: "user-helmet-safety",
  icon: [448, 512, [128119, "user-construction", "user-hard-hat"], "f82c", "M216 0c-13.3 0-24 10.7-24 24V80L163.6 23.1C125.6 43.5 99 82.6 96.2 128H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24h-.2C349 82.6 322.4 43.5 284.4 23.1L256 80V24c0-13.3-10.7-24-24-24H216zm8 320c65.3 0 119.1-48.9 127-112H97c7.9 63.1 61.7 112 127 112zm-89.6 32C60.2 352 0 412.2 0 486.4C0 500.5 11.5 512 25.6 512H422.4c14.1 0 25.6-11.5 25.6-25.6C448 412.2 387.8 352 313.6 352H134.4z"]
}, V6 = {
  prefix: "fas",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
}, C6 = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, k6 = {
  prefix: "fas",
  iconName: "cloud-arrow-up",
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"]
}, w6 = {
  prefix: "fas",
  iconName: "triangle-person-digging",
  icon: [640, 512, ["construction"], "f85d", "M354.5 51.8C347.3 39.5 334.2 32 320 32s-27.3 7.5-34.5 19.8l-216 368c-7.3 12.4-7.3 27.7-.2 40.1S89.7 480 104 480H536c14.3 0 27.6-7.7 34.7-20.1s7-27.8-.2-40.1l-216-368zM216.9 304.7l15.6 9.8 64 40c4.7 2.9 7.5 8.1 7.5 13.6v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V376.9l-40.9-25.5-24.5 55.2c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l32-72 7.5-16.8zm112-45.7l19.7 49.2L402 339l16.3-27.2c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l48 80c3 4.9 3 11.1 .2 16.1s-8.2 8.1-13.9 8.1H384c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l15.2-25.4L232 277.9c-3.8-2.2-6.6-5.9-7.6-10.2s-.2-8.8 2.3-12.5l4.2-6.4c10.3-15.5 27.7-24.8 46.3-24.8c22.7 0 43.2 13.8 51.6 34.9zM288 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
}, N6 = w6, A6 = {
  prefix: "fas",
  iconName: "cloud-bolt",
  icon: [512, 512, [127785, "thunderstorm"], "f76c", "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"]
}, S6 = {
  prefix: "fas",
  iconName: "file-contract",
  icon: [384, 512, [], "f56c", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"]
}, P6 = {
  prefix: "fas",
  iconName: "telescope",
  icon: [576, 512, [128301], "e03e", "M375.7 40c-15.3 8.8-20.6 28.4-11.7 43.7L460 250c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-96-166.3C466 4.4 446.4-.8 431.1 8L375.7 40zM11.8 343.6C.4 350.3-3.6 364.9 3.1 376.4l25.9 44.9c6.6 11.5 21.3 15.4 32.8 8.8l44.1-25.5 .8 1.4c8.6 15 27.6 20.4 42.8 12.2l88.4-47.4L193.8 478.9c-5 12.3 .9 26.3 13.2 31.3s26.3-.9 31.3-13.2L304 335.6l65.8 161.4c5 12.3 19 18.2 31.3 13.2s18.2-19 13.2-31.3L346.4 312.5l86.1-46.2-.2-.3-96-166.3c-1-1.8-2-3.6-2.8-5.4L62.4 268.4c-14.4 9.2-19 28.1-10.4 42.9l4 6.9L11.8 343.6z"]
}, O6 = {
  prefix: "fas",
  iconName: "circle-question",
  icon: [512, 512, [62108, "question-circle"], "f059", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, E6 = {
  prefix: "fas",
  iconName: "pen",
  icon: [512, 512, [128394], "f304", "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"]
}, $6 = {
  prefix: "fas",
  iconName: "scale-unbalanced",
  icon: [640, 512, ["balance-scale-left"], "f515", "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288H439.6zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"]
}, I6 = {
  prefix: "fas",
  iconName: "hand-holding-dollar",
  icon: [576, 512, ["hand-holding-usd"], "f4c0", "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3 0 0c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"]
}, T6 = {
  prefix: "fas",
  iconName: "house-person-leave",
  icon: [640, 512, ["house-leave", "house-person-depart"], "e00f", "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0L379.5 117.2c-32.6 19.5-57.5 50.2-69.6 86.7l-2.6 7.8c-11.2 33.5 6.9 69.8 40.5 81c15.8 5.3 32.2 4 46.3-2.3L361.5 372l-44 44H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM128 208v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM528 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM443.7 200.5l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L601 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L567 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5c-1 .4-1.9 .8-2.9 1.2zm-30 135.1c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1l-61.7 61.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L388.7 398l25-62.4z"]
}, _6 = T6, R6 = {
  prefix: "fas",
  iconName: "phone",
  icon: [512, 512, [128222, 128379], "f095", "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"]
}, D6 = {
  prefix: "fas",
  iconName: "rocket-launch",
  icon: [512, 512, [128640], "e027", "M117.8 128H207C286.9-3.7 409.5-8.5 483.9 5.3c11.6 2.2 20.7 11.2 22.8 22.8c13.8 74.4 9 197-122.7 276.9v89.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-114.7c0-22.6-9-44.3-25-60.3s-37.7-25-60.3-25H24c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3zM424 128a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM166.5 470C132.3 504.3 66 511 28.3 511.9c-16 .4-28.6-12.2-28.2-28.2C1 446 7.7 379.7 42 345.5c34.4-34.4 90.1-34.4 124.5 0s34.4 90.1 0 124.5zm-46.7-36.4c11.4-11.4 11.4-30 0-41.4s-30-11.4-41.4 0c-10.1 10.1-13 28.5-13.7 41.3c-.5 8 5.9 14.3 13.9 13.9c12.8-.7 31.2-3.7 41.3-13.7z"]
}, F6 = {
  prefix: "fas",
  iconName: "garage-car",
  icon: [640, 512, [], "e00a", "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM254.3 293.4L242.2 328H397.8l-12.1-34.6c-1.1-3.2-4.2-5.4-7.6-5.4H261.8c-3.4 0-6.4 2.2-7.6 5.4zM188.9 335L209 277.5c7.9-22.5 29.1-37.5 52.9-37.5H378.2c23.8 0 45 15.1 52.9 37.5L451.1 335c17.2 9.5 28.9 27.9 28.9 49v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V464H224v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-21.1 11.7-39.5 28.9-49zM240 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
}, j6 = {
  prefix: "fas",
  iconName: "person-digging",
  icon: [576, 512, ["digging"], "f85e", "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"]
}, Y6 = {
  prefix: "fas",
  iconName: "trash",
  icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"]
}, U6 = {
  prefix: "fas",
  iconName: "file-pdf",
  icon: [512, 512, [], "f1c1", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
}, W6 = {
  prefix: "fas",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
}, q6 = {
  prefix: "fas",
  iconName: "calendar-check",
  icon: [448, 512, [], "f274", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"]
}, B6 = {
  prefix: "fas",
  iconName: "calendar-clock",
  icon: [576, 512, ["calendar-time"], "e0d2", "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H432 0V464c0 26.5 21.5 48 48 48H330.8C285.6 480.1 256 427.5 256 368c0-97.2 78.8-176 176-176c5.4 0 10.7 .2 16 .7V192zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM432 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"]
}, X6 = {
  prefix: "fas",
  iconName: "arrow-down-arrow-up",
  icon: [576, 512, ["sort-alt"], "f883", "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L128 370.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V370.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96zm352-333.3c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L448 141.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V141.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96z"]
}, G6 = X6, K6 = {
  prefix: "fas",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
}, Q6 = {
  prefix: "fas",
  iconName: "calendar-week",
  icon: [448, 512, [], "f784", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"]
}, Z6 = {
  prefix: "fas",
  iconName: "car",
  icon: [512, 512, [128664, "automobile"], "f1b9", "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, J6 = {
  prefix: "fas",
  iconName: "square-pen",
  icon: [448, 512, ["pen-square", "pencil-square"], "f14b", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"]
}, a0 = J6, e0 = {
  prefix: "fas",
  iconName: "money-bill-simple-wave",
  icon: [576, 512, [], "e1f2", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]
}, n0 = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, t0 = {
  prefix: "fas",
  iconName: "car-burst",
  icon: [640, 512, ["car-crash"], "f5e1", "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"]
}, r0 = t0, c0 = {
  prefix: "fas",
  iconName: "copy",
  icon: [512, 512, [], "f0c5", "M272 0H396.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128H192v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"]
}, i0 = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, o0 = {
  prefix: "fas",
  iconName: "rocket",
  icon: [512, 512, [], "f135", "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
}, s0 = {
  prefix: "fas",
  iconName: "spinner",
  icon: [512, 512, [], "f110", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"]
}, l0 = {
  prefix: "fas",
  iconName: "clock-rotate-left",
  icon: [512, 512, ["history"], "f1da", "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"]
}, f0 = l0, u0 = {
  prefix: "fas",
  iconName: "file-export",
  icon: [576, 512, ["arrow-right-from-file"], "f56e", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"]
}, m0 = {
  prefix: "fas",
  iconName: "circle-plus",
  icon: [512, 512, ["plus-circle"], "f055", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
}, v0 = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
}, d0 = {
  prefix: "fas",
  iconName: "calendar-day",
  icon: [448, 512, [], "f783", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"]
}, p0 = {
  prefix: "fas",
  iconName: "bandage",
  icon: [640, 512, [129657, "band-aid"], "f462", "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
}, h0 = p0, g0 = {
  prefix: "fas",
  iconName: "user-injured",
  icon: [448, 512, [], "f728", "M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"]
};
X3.add(
  Pa,
  $a,
  qa,
  Za,
  ue,
  fe,
  La,
  xa,
  Ya,
  ne,
  Ua,
  Ia,
  Aa,
  ba,
  ma,
  Va,
  wa,
  ie,
  Ca,
  fa,
  oe,
  ka,
  ae,
  ua,
  Ra,
  Oa,
  Ga,
  ya,
  ee,
  Ta,
  Ea,
  Na,
  pa,
  _a,
  Ha,
  se,
  Wa,
  Fa,
  Da,
  Ka,
  ga,
  la,
  Ja,
  ce,
  re,
  Xa,
  da,
  ha,
  za,
  $e,
  _e,
  Ge,
  e6,
  d6,
  v6,
  ke,
  Ce,
  qe,
  c6,
  Be,
  Re,
  Oe,
  He,
  pe,
  we,
  Se,
  l6,
  Ne,
  ve,
  f6,
  Ae,
  t6,
  de,
  je,
  Ie,
  Ze,
  xe,
  r6,
  De,
  Te,
  Pe,
  be,
  Fe,
  Le,
  u6,
  Xe,
  Ue,
  Ye,
  Je,
  ye,
  me,
  n6,
  s6,
  o6,
  Qe,
  ge,
  ze,
  Me,
  _6,
  F6,
  Z6,
  r0,
  g0,
  h0,
  A6,
  N6,
  G6,
  s0,
  K6,
  j6,
  I6,
  L6,
  b6,
  S6,
  E6,
  m0,
  P6,
  h6,
  v0,
  O6,
  i0,
  g6,
  W6,
  R6,
  e0,
  C6,
  o0,
  Y6,
  D6,
  $6,
  H6,
  U6,
  k6,
  d0,
  Q6,
  B6,
  q6,
  n0,
  x6,
  p6,
  c0,
  u0,
  f0,
  a0,
  y6,
  M6,
  V6
);
const M0 = [
  "house-leave",
  "garage-car",
  "car",
  "car-crash",
  "user-injured",
  "band-aid",
  "cloud-bolt",
  "construction",
  "sort-alt",
  "spinner",
  "house",
  "person-digging",
  "hand-holding-dollar",
  "user-helmet-safety",
  "chevrons-left",
  "file-contract",
  "pen",
  "circle-plus",
  "telescope",
  "message-bot",
  "check",
  "circle-question",
  "xmark",
  "message-exclamation",
  "circle-info",
  "phone",
  "money-bill-simple-wave",
  "circle-check",
  "rocket-launch",
  "scale-unbalanced",
  "circle-exclamation",
  "trash",
  "file-pdf",
  "cloud-arrow-up",
  "calendar-day",
  "calendar-week",
  "calendar-clock",
  "calendar-check",
  "chevron-down",
  "chevron-up",
  "circle-minus",
  "copy",
  "file-export",
  "history",
  "pencil-square",
  "pencil-alt",
  "pen-to-square",
  "sparkles"
].sort((a, e) => a.localeCompare(e)), b0 = [
  { theme: "duo", kendoTheme: "fad" },
  { theme: "solid", kendoTheme: "fas" },
  { theme: "thin", kendoTheme: "fat" }
], x0 = ({ size: a, ...e }) => {
  var i;
  const t = `${e.color ?? "primary"}-color ` + e.className, c = [((i = b0.find((o) => o.theme === e.theme)) == null ? void 0 : i.kendoTheme) ?? "fad", e.icon];
  return a === "auto" ? /* @__PURE__ */ f2.jsx(
    J,
    {
      ...e,
      icon: c,
      className: t,
      style: {
        width: "100%",
        height: "100%"
      }
    }
  ) : /* @__PURE__ */ f2.jsx(J, { size: a, ...e, icon: c, className: t });
};
export {
  x0 as Icon,
  M0 as supportedIcons
};
